import {
  __decorateClass
} from "./chunk-EUXUH3YW.js";

// libs/widgets/src/lib/swap-form/i18n/index.ts
import { addTranslation } from "@one-inch-community/core/lit";
import { Locale } from "@one-inch-community/models";
addTranslation({
  [Locale.en]: () => import("./en-2MFTSBRT.js").then((m) => m.default),
  [Locale.ar]: () => import("./ar-EHVYY5BX.js").then((m) => m.default),
  [Locale.fr]: () => import("./fr-CR6ZYPHE.js").then((m) => m.default),
  [Locale.es]: () => import("./es-V55QBK65.js").then((m) => m.default),
  [Locale.de]: () => import("./de-JMXTJR4F.js").then((m) => m.default)
});

// libs/widgets/src/lib/swap-form/swap-from.element.ts
import { html as html10, LitElement as LitElement10 } from "lit";
import { consume as consume9 } from "@lit/context";
import { customElement as customElement10 } from "lit/decorators.js";
import "@one-inch-community/ui-components/card";
import "@one-inch-community/ui-components/icon";
import "@one-inch-community/ui-components/button";
import { ApplicationContextToken as ApplicationContextToken6, EmbeddedConfigToken as EmbeddedConfigToken3 } from "@one-inch-community/core/application-context";
import { SwapContextToken as SwapContextToken8 } from "@one-inch-community/sdk/swap";
import { combineLatest as combineLatest6, defer as defer7, distinctUntilChanged as distinctUntilChanged3, map as map7, startWith as startWith5 } from "rxjs";
import { observe as observe6, translate as translate6 } from "@one-inch-community/core/lit";

// libs/widgets/src/lib/swap-form/swap-from.style.ts
import { css } from "lit";
var swapFromStyle = css`

    .swap-form-container {
        display: flex;
        flex-direction: column;
        gap: 8px;
        height: fit-content;
        width: 100%;
        min-width: 300px;
    }

    .input-container {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .input-header {
        height: 68px;
        padding: 16px 0 16px 8px;
        box-sizing: border-box;
        color: var(--color-content-content-primary);
        font-size: 20px;
        font-weight: 600;
        line-height: 28px;
        margin-top: -16px;
        letter-spacing: 0;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

`;

// libs/widgets/src/lib/swap-form/elements/input/input.element.ts
import { html as html3, LitElement as LitElement3 } from "lit";
import { customElement as customElement3, property as property3, state } from "lit/decorators.js";
import { consume as consume3 } from "@lit/context";
import { classMap } from "lit/directives/class-map.js";
import { ifDefined } from "lit/directives/if-defined.js";
import {
  combineLatest as combineLatest3,
  defer as defer3,
  filter as filter3,
  from,
  map as map3,
  of,
  shareReplay,
  startWith as startWith2,
  switchMap as switchMap3,
  tap
} from "rxjs";

// node_modules/.pnpm/@maskito+core@2.5.0/node_modules/@maskito/core/index.esm.js
var MASKITO_DEFAULT_OPTIONS = {
  mask: /^.*$/,
  preprocessors: [],
  postprocessors: [],
  plugins: [],
  overwriteMode: "shift"
};
var MaskHistory = class {
  constructor() {
    this.now = null;
    this.past = [];
    this.future = [];
  }
  undo() {
    const state4 = this.past.pop();
    if (state4 && this.now) {
      this.future.push(this.now);
      this.updateElement(state4, "historyUndo");
    }
  }
  redo() {
    const state4 = this.future.pop();
    if (state4 && this.now) {
      this.past.push(this.now);
      this.updateElement(state4, "historyRedo");
    }
  }
  updateHistory(state4) {
    if (!this.now) {
      this.now = state4;
      return;
    }
    const isValueChanged = this.now.value !== state4.value;
    const isSelectionChanged = this.now.selection.some((item, index) => item !== state4.selection[index]);
    if (!isValueChanged && !isSelectionChanged) {
      return;
    }
    if (isValueChanged) {
      this.past.push(this.now);
      this.future = [];
    }
    this.now = state4;
  }
  updateElement(state4, inputType) {
    this.now = state4;
    this.updateElementState(state4, { inputType, data: null });
  }
};
function areElementValuesEqual(sampleState, ...states) {
  return states.every(({ value }) => value === sampleState.value);
}
function areElementStatesEqual(sampleState, ...states) {
  return states.every(({ value, selection }) => value === sampleState.value && selection[0] === sampleState.selection[0] && selection[1] === sampleState.selection[1]);
}
function applyOverwriteMode({ value, selection }, newCharacters, mode) {
  const [from2, to] = selection;
  const computedMode = typeof mode === "function" ? mode({ value, selection }) : mode;
  return {
    value,
    selection: computedMode === "replace" ? [from2, from2 + newCharacters.length] : [from2, to]
  };
}
function isFixedCharacter(char) {
  return typeof char === "string";
}
function getLeadingFixedCharacters(mask, validatedValuePart, newCharacter, initialElementState) {
  let leadingFixedCharacters = "";
  for (let i = validatedValuePart.length; i < mask.length; i++) {
    const charConstraint = mask[i];
    const isInitiallyExisted = (initialElementState === null || initialElementState === void 0 ? void 0 : initialElementState.value[i]) === charConstraint;
    if (!isFixedCharacter(charConstraint) || charConstraint === newCharacter && !isInitiallyExisted) {
      return leadingFixedCharacters;
    }
    leadingFixedCharacters += charConstraint;
  }
  return leadingFixedCharacters;
}
function validateValueWithMask(value, maskExpression) {
  if (Array.isArray(maskExpression)) {
    return value.length === maskExpression.length && Array.from(value).every((char, i) => {
      const charConstraint = maskExpression[i];
      return isFixedCharacter(charConstraint) ? char === charConstraint : char.match(charConstraint);
    });
  }
  return maskExpression.test(value);
}
function guessValidValueByPattern(elementState, mask, initialElementState) {
  let maskedFrom = null;
  let maskedTo = null;
  const maskedValue = Array.from(elementState.value).reduce((validatedCharacters, char, charIndex) => {
    const leadingCharacters = getLeadingFixedCharacters(mask, validatedCharacters, char, initialElementState);
    const newValidatedChars = validatedCharacters + leadingCharacters;
    const charConstraint = mask[newValidatedChars.length];
    if (isFixedCharacter(charConstraint)) {
      return newValidatedChars + charConstraint;
    }
    if (!char.match(charConstraint)) {
      return newValidatedChars;
    }
    if (maskedFrom === null && charIndex >= elementState.selection[0]) {
      maskedFrom = newValidatedChars.length;
    }
    if (maskedTo === null && charIndex >= elementState.selection[1]) {
      maskedTo = newValidatedChars.length;
    }
    return newValidatedChars + char;
  }, "");
  const trailingFixedCharacters = getLeadingFixedCharacters(mask, maskedValue, "", initialElementState);
  return {
    value: validateValueWithMask(maskedValue + trailingFixedCharacters, mask) ? maskedValue + trailingFixedCharacters : maskedValue,
    selection: [maskedFrom !== null && maskedFrom !== void 0 ? maskedFrom : maskedValue.length, maskedTo !== null && maskedTo !== void 0 ? maskedTo : maskedValue.length]
  };
}
function guessValidValueByRegExp({ value, selection }, maskRegExp) {
  const [from2, to] = selection;
  let newFrom = from2;
  let newTo = to;
  const validatedValue = Array.from(value).reduce((validatedValuePart, char, i) => {
    const newPossibleValue = validatedValuePart + char;
    if (from2 === i) {
      newFrom = validatedValuePart.length;
    }
    if (to === i) {
      newTo = validatedValuePart.length;
    }
    return newPossibleValue.match(maskRegExp) ? newPossibleValue : validatedValuePart;
  }, "");
  return { value: validatedValue, selection: [newFrom, newTo] };
}
function calibrateValueByMask(elementState, mask, initialElementState = null) {
  if (validateValueWithMask(elementState.value, mask)) {
    return elementState;
  }
  const { value, selection } = Array.isArray(mask) ? guessValidValueByPattern(elementState, mask, initialElementState) : guessValidValueByRegExp(elementState, mask);
  return {
    selection,
    value: Array.isArray(mask) ? value.slice(0, mask.length) : value
  };
}
function removeFixedMaskCharacters(initialElementState, mask) {
  if (!Array.isArray(mask)) {
    return initialElementState;
  }
  const [from2, to] = initialElementState.selection;
  const selection = [];
  const unmaskedValue = Array.from(initialElementState.value).reduce((rawValue, char, i) => {
    const charConstraint = mask[i];
    if (i === from2) {
      selection.push(rawValue.length);
    }
    if (i === to) {
      selection.push(rawValue.length);
    }
    return isFixedCharacter(charConstraint) && charConstraint === char ? rawValue : rawValue + char;
  }, "");
  if (selection.length < 2) {
    selection.push(...new Array(2 - selection.length).fill(unmaskedValue.length));
  }
  return {
    value: unmaskedValue,
    selection: [selection[0], selection[1]]
  };
}
var MaskModel = class {
  constructor(initialElementState, maskOptions) {
    this.initialElementState = initialElementState;
    this.maskOptions = maskOptions;
    this.value = "";
    this.selection = [0, 0];
    const { value, selection } = calibrateValueByMask(this.initialElementState, this.getMaskExpression(this.initialElementState));
    this.value = value;
    this.selection = selection;
  }
  addCharacters([from2, to], newCharacters) {
    const { value } = this;
    const maskExpression = this.getMaskExpression({
      value: value.slice(0, from2) + newCharacters + value.slice(to),
      selection: [from2 + newCharacters.length, from2 + newCharacters.length]
    });
    const initialElementState = { value, selection: [from2, to] };
    const unmaskedElementState = removeFixedMaskCharacters(initialElementState, maskExpression);
    const [unmaskedFrom, unmaskedTo] = applyOverwriteMode(unmaskedElementState, newCharacters, this.maskOptions.overwriteMode).selection;
    const newUnmaskedLeadingValuePart = unmaskedElementState.value.slice(0, unmaskedFrom) + newCharacters;
    const newCaretIndex = newUnmaskedLeadingValuePart.length;
    const maskedElementState = calibrateValueByMask({
      value: newUnmaskedLeadingValuePart + unmaskedElementState.value.slice(unmaskedTo),
      selection: [newCaretIndex, newCaretIndex]
    }, maskExpression, initialElementState);
    const isInvalidCharsInsertion = (
      // eslint-disable-next-line @typescript-eslint/prefer-string-starts-ends-with
      value.slice(0, unmaskedFrom) === calibrateValueByMask({
        value: newUnmaskedLeadingValuePart,
        selection: [newCaretIndex, newCaretIndex]
      }, maskExpression, initialElementState).value
    );
    if (isInvalidCharsInsertion || areElementStatesEqual(this, maskedElementState)) {
      throw new Error("Invalid mask value");
    }
    this.value = maskedElementState.value;
    this.selection = maskedElementState.selection;
  }
  deleteCharacters([from2, to]) {
    if (from2 === to || !to) {
      return;
    }
    const { value } = this;
    const maskExpression = this.getMaskExpression({
      value: value.slice(0, from2) + value.slice(to),
      selection: [from2, from2]
    });
    const initialElementState = { value, selection: [from2, to] };
    const unmaskedElementState = removeFixedMaskCharacters(initialElementState, maskExpression);
    const [unmaskedFrom, unmaskedTo] = unmaskedElementState.selection;
    const newUnmaskedValue = unmaskedElementState.value.slice(0, unmaskedFrom) + unmaskedElementState.value.slice(unmaskedTo);
    const maskedElementState = calibrateValueByMask({ value: newUnmaskedValue, selection: [unmaskedFrom, unmaskedFrom] }, maskExpression, initialElementState);
    this.value = maskedElementState.value;
    this.selection = maskedElementState.selection;
  }
  getMaskExpression(elementState) {
    const { mask } = this.maskOptions;
    return typeof mask === "function" ? mask(elementState) : mask;
  }
};
var EventListener = class {
  constructor(element) {
    this.element = element;
    this.listeners = [];
  }
  listen(eventType, fn, options) {
    const untypedFn = fn;
    this.element.addEventListener(eventType, untypedFn, options);
    this.listeners.push(() => this.element.removeEventListener(eventType, untypedFn));
  }
  destroy() {
    this.listeners.forEach((stopListen) => stopListen());
  }
};
var HotkeyModifier = {
  CTRL: 1 << 0,
  ALT: 1 << 1,
  SHIFT: 1 << 2,
  META: 1 << 3
};
var HotkeyCode = {
  Y: 89,
  Z: 90
};
function isHotkey(event, modifiers, hotkeyCode) {
  return event.ctrlKey === !!(modifiers & HotkeyModifier.CTRL) && event.altKey === !!(modifiers & HotkeyModifier.ALT) && event.shiftKey === !!(modifiers & HotkeyModifier.SHIFT) && event.metaKey === !!(modifiers & HotkeyModifier.META) && /**
   * We intentionally use legacy {@link KeyboardEvent#keyCode `keyCode`} property. It is more
   * "keyboard-layout"-independent than {@link KeyboardEvent#key `key`} or {@link KeyboardEvent#code `code`} properties.
   * @see {@link https://github.com/taiga-family/maskito/issues/315 `KeyboardEvent#code` issue}
   */
  event.keyCode === hotkeyCode;
}
function isRedo(event) {
  return isHotkey(event, HotkeyModifier.CTRL, HotkeyCode.Y) || // Windows
  isHotkey(event, HotkeyModifier.CTRL | HotkeyModifier.SHIFT, HotkeyCode.Z) || // Windows & Android
  isHotkey(event, HotkeyModifier.META | HotkeyModifier.SHIFT, HotkeyCode.Z);
}
function isUndo(event) {
  return isHotkey(event, HotkeyModifier.CTRL, HotkeyCode.Z) || // Windows & Android
  isHotkey(event, HotkeyModifier.META, HotkeyCode.Z);
}
function maskitoUpdateElement(element, valueOrElementState) {
  var _a;
  const initialValue = element.value;
  if (typeof valueOrElementState === "string") {
    element.value = valueOrElementState;
  } else {
    const [from2, to] = valueOrElementState.selection;
    element.value = valueOrElementState.value;
    if (element.matches(":focus")) {
      (_a = element.setSelectionRange) === null || _a === void 0 ? void 0 : _a.call(element, from2, to);
    }
  }
  if (element.value !== initialValue) {
    element.dispatchEvent(new Event(
      "input",
      /**
       * React handles this event only on bubbling phase
       *
       * here is the list of events that are processed in the capture stage, others are processed in the bubbling stage
       * https://github.com/facebook/react/blob/cb2439624f43c510007f65aea5c50a8bb97917e4/packages/react-dom-bindings/src/events/DOMPluginEventSystem.js#L222
       */
      { bubbles: true }
    ));
  }
}
function getLineSelection({ value, selection }, isForward) {
  const [from2, to] = selection;
  if (from2 !== to) {
    return [from2, to];
  }
  const nearestBreak = isForward ? value.slice(from2).indexOf("\n") + 1 || value.length : value.slice(0, to).lastIndexOf("\n") + 1;
  const selectFrom = isForward ? from2 : nearestBreak;
  const selectTo = isForward ? nearestBreak : to;
  return [selectFrom, selectTo];
}
function getNotEmptySelection({ value, selection }, isForward) {
  const [from2, to] = selection;
  if (from2 !== to) {
    return [from2, to];
  }
  const notEmptySelection = isForward ? [from2, to + 1] : [from2 - 1, to];
  return notEmptySelection.map((x) => Math.min(Math.max(x, 0), value.length));
}
var TRAILING_SPACES_REG = /\s+$/g;
var LEADING_SPACES_REG = /^\s+/g;
var SPACE_REG = /\s/;
function getWordSelection({ value, selection }, isForward) {
  const [from2, to] = selection;
  if (from2 !== to) {
    return [from2, to];
  }
  if (isForward) {
    const valueAfterSelectionStart = value.slice(from2);
    const [leadingSpaces] = valueAfterSelectionStart.match(LEADING_SPACES_REG) || [
      ""
    ];
    const nearestWordEndIndex = valueAfterSelectionStart.trimStart().search(SPACE_REG);
    return [
      from2,
      nearestWordEndIndex !== -1 ? from2 + leadingSpaces.length + nearestWordEndIndex : value.length
    ];
  }
  const valueBeforeSelectionEnd = value.slice(0, to);
  const [trailingSpaces] = valueBeforeSelectionEnd.match(TRAILING_SPACES_REG) || [""];
  const selectedWordLength = valueBeforeSelectionEnd.trimEnd().split("").reverse().findIndex((char) => char.match(SPACE_REG));
  return [
    selectedWordLength !== -1 ? to - trailingSpaces.length - selectedWordLength : 0,
    to
  ];
}
function maskitoPipe(processors = []) {
  return (initialData, ...readonlyArgs) => processors.reduce((data, fn) => Object.assign(Object.assign({}, data), fn(data, ...readonlyArgs)), initialData);
}
function maskitoTransform(valueOrState, maskitoOptions) {
  const options = Object.assign(Object.assign({}, MASKITO_DEFAULT_OPTIONS), maskitoOptions);
  const preprocessor = maskitoPipe(options.preprocessors);
  const postprocessor = maskitoPipe(options.postprocessors);
  const initialElementState = typeof valueOrState === "string" ? { value: valueOrState, selection: [0, 0] } : valueOrState;
  const { elementState } = preprocessor({ elementState: initialElementState, data: "" }, "validation");
  const maskModel = new MaskModel(elementState, options);
  const { value, selection } = postprocessor(maskModel, initialElementState);
  return typeof valueOrState === "string" ? value : { value, selection };
}
var Maskito = class extends MaskHistory {
  constructor(element, maskitoOptions) {
    super();
    this.element = element;
    this.maskitoOptions = maskitoOptions;
    this.isTextArea = this.element.nodeName === "TEXTAREA";
    this.eventListener = new EventListener(this.element);
    this.options = Object.assign(Object.assign({}, MASKITO_DEFAULT_OPTIONS), this.maskitoOptions);
    this.preprocessor = maskitoPipe(this.options.preprocessors);
    this.postprocessor = maskitoPipe(this.options.postprocessors);
    this.teardowns = this.options.plugins.map((plugin) => plugin(this.element, this.options));
    this.updateHistory(this.elementState);
    this.eventListener.listen("keydown", (event) => {
      if (isRedo(event)) {
        event.preventDefault();
        return this.redo();
      }
      if (isUndo(event)) {
        event.preventDefault();
        return this.undo();
      }
    });
    this.eventListener.listen("beforeinput", (event) => {
      var _a;
      const isForward = event.inputType.includes("Forward");
      this.updateHistory(this.elementState);
      switch (event.inputType) {
        // historyUndo/historyRedo will not be triggered if value was modified programmatically
        case "historyUndo":
          event.preventDefault();
          return this.undo();
        case "historyRedo":
          event.preventDefault();
          return this.redo();
        case "deleteByCut":
        case "deleteContentBackward":
        case "deleteContentForward":
          return this.handleDelete({
            event,
            isForward,
            selection: getNotEmptySelection(this.elementState, isForward)
          });
        case "deleteWordForward":
        case "deleteWordBackward":
          return this.handleDelete({
            event,
            isForward,
            selection: getWordSelection(this.elementState, isForward),
            force: true
          });
        case "deleteSoftLineBackward":
        case "deleteSoftLineForward":
        case "deleteHardLineBackward":
        case "deleteHardLineForward":
          return this.handleDelete({
            event,
            isForward,
            selection: getLineSelection(this.elementState, isForward),
            force: true
          });
        case "insertCompositionText":
          return;
        // will be handled inside `compositionend` event
        case "insertReplacementText":
          return;
        case "insertLineBreak":
        case "insertParagraph":
          return this.handleEnter(event);
        case "insertFromPaste":
        case "insertText":
        case "insertFromDrop":
        default:
          return this.handleInsert(event, event.data || // `event.data` for `contentEditable` is always `null` for paste/drop events
          ((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.getData("text/plain")) || "");
      }
    });
    this.eventListener.listen("input", ({ inputType }) => {
      if (inputType === "insertCompositionText") {
        return;
      }
      this.ensureValueFitsMask();
      this.updateHistory(this.elementState);
    });
    this.eventListener.listen("compositionend", () => {
      this.ensureValueFitsMask();
      this.updateHistory(this.elementState);
    });
  }
  get elementState() {
    const { value, selectionStart, selectionEnd } = this.element;
    return {
      value,
      selection: [selectionStart || 0, selectionEnd || 0]
    };
  }
  get maxLength() {
    const { maxLength } = this.element;
    return maxLength === -1 ? Infinity : maxLength;
  }
  destroy() {
    this.eventListener.destroy();
    this.teardowns.forEach((teardown) => teardown === null || teardown === void 0 ? void 0 : teardown());
  }
  updateElementState({ value, selection }, eventInit = {
    inputType: "insertText",
    data: null
  }) {
    const initialValue = this.elementState.value;
    this.updateValue(value);
    this.updateSelectionRange(selection);
    if (initialValue !== value) {
      this.dispatchInputEvent(eventInit);
    }
  }
  updateSelectionRange([from2, to]) {
    var _a;
    const { element } = this;
    if (element.matches(":focus") && (element.selectionStart !== from2 || element.selectionEnd !== to)) {
      (_a = element.setSelectionRange) === null || _a === void 0 ? void 0 : _a.call(element, from2, to);
    }
  }
  updateValue(value) {
    this.element.value = value;
  }
  ensureValueFitsMask() {
    this.updateElementState(maskitoTransform(this.elementState, this.options));
  }
  dispatchInputEvent(eventInit = {
    inputType: "insertText",
    data: null
  }) {
    if (globalThis.InputEvent) {
      this.element.dispatchEvent(new InputEvent("input", Object.assign(Object.assign({}, eventInit), { bubbles: true, cancelable: false })));
    }
  }
  handleDelete({ event, selection, isForward, force = false }) {
    const initialState = {
      value: this.elementState.value,
      selection
    };
    const [initialFrom, initialTo] = initialState.selection;
    const { elementState } = this.preprocessor({
      elementState: initialState,
      data: ""
    }, isForward ? "deleteForward" : "deleteBackward");
    const maskModel = new MaskModel(elementState, this.options);
    const [from2, to] = elementState.selection;
    maskModel.deleteCharacters([from2, to]);
    const newElementState = this.postprocessor(maskModel, initialState);
    const newPossibleValue = initialState.value.slice(0, initialFrom) + initialState.value.slice(initialTo);
    if (newPossibleValue === newElementState.value && !force && !this.element.isContentEditable) {
      return;
    }
    event.preventDefault();
    if (areElementValuesEqual(initialState, elementState, maskModel, newElementState)) {
      return this.updateSelectionRange(isForward ? [to, to] : [from2, from2]);
    }
    this.updateElementState(newElementState, {
      inputType: event.inputType,
      data: null
    });
    this.updateHistory(newElementState);
  }
  handleInsert(event, data) {
    const initialElementState = this.elementState;
    const { elementState, data: insertedText = data } = this.preprocessor({
      data,
      elementState: initialElementState
    }, "insert");
    const maskModel = new MaskModel(elementState, this.options);
    try {
      maskModel.addCharacters(elementState.selection, insertedText);
    } catch (_a) {
      return event.preventDefault();
    }
    const [from2, to] = elementState.selection;
    const newPossibleValue = initialElementState.value.slice(0, from2) + data + initialElementState.value.slice(to);
    const newElementState = this.postprocessor(maskModel, initialElementState);
    if (newElementState.value.length > this.maxLength) {
      return event.preventDefault();
    }
    if (newPossibleValue !== newElementState.value || this.element.isContentEditable) {
      event.preventDefault();
      this.updateElementState(newElementState, {
        data,
        inputType: event.inputType
      });
      this.updateHistory(newElementState);
    }
  }
  handleEnter(event) {
    if (this.isTextArea || this.element.isContentEditable) {
      this.handleInsert(event, "\n");
    }
  }
};

// node_modules/.pnpm/@maskito+kit@2.5.0_@maskito+core@2.5.0/node_modules/@maskito/kit/index.esm.js
function clamp(value, min, max) {
  const clampedValue = Math.min(Number(max), Math.max(Number(min), Number(value)));
  return value instanceof Date ? new Date(clampedValue) : clampedValue;
}
var DEFAULT_DECIMAL_PSEUDO_SEPARATORS = [".", ",", "\u0431", "\u044E"];
var TIME_FIXED_CHARACTERS = [":", "."];
var CHAR_NO_BREAK_SPACE = "\xA0";
var CHAR_ZERO_WIDTH_SPACE = "\u200B";
var CHAR_EN_DASH = "\u2013";
var CHAR_EM_DASH = "\u2014";
var CHAR_HYPHEN = "-";
var CHAR_MINUS = "\u2212";
var CHAR_JP_HYPHEN = "\u30FC";
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reHasRegExpChar = new RegExp(reRegExpChar.source);
function escapeRegExp(str) {
  return str && reHasRegExpChar.test(str) ? str.replaceAll(reRegExpChar, "\\$&") : str;
}
function extractAffixes(value, { prefix, postfix }) {
  var _a, _b;
  const prefixRegExp = new RegExp(`^${escapeRegExp(prefix)}`);
  const postfixRegExp = new RegExp(`${escapeRegExp(postfix)}$`);
  const [extractedPrefix = ""] = (_a = value.match(prefixRegExp)) !== null && _a !== void 0 ? _a : [];
  const [extractedPostfix = ""] = (_b = value.match(postfixRegExp)) !== null && _b !== void 0 ? _b : [];
  const cleanValue = value.replace(prefixRegExp, "").replace(postfixRegExp, "");
  return { extractedPrefix, extractedPostfix, cleanValue };
}
function findCommonBeginningSubstr(a, b) {
  let res = "";
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return res;
    }
    res += a[i];
  }
  return res;
}
function identity(x) {
  return x;
}
function toHalfWidthNumber(fullWidthNumber) {
  return fullWidthNumber.replaceAll(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 65248));
}
function createFullWidthToHalfWidthPreprocessor() {
  return ({ elementState, data }) => {
    const { value, selection } = elementState;
    return {
      elementState: {
        selection,
        value: toHalfWidthNumber(value)
      },
      data: toHalfWidthNumber(data)
    };
  };
}
function maskitoPostfixPostprocessorGenerator(postfix) {
  const postfixRE = new RegExp(`${escapeRegExp(postfix)}$`);
  return postfix ? ({ value, selection }, initialElementState) => {
    if (!value && !initialElementState.value.endsWith(postfix)) {
      return { value, selection };
    }
    if (!value.endsWith(postfix) && !initialElementState.value.endsWith(postfix)) {
      return { selection, value: value + postfix };
    }
    const initialValueBeforePostfix = initialElementState.value.replace(postfixRE, "");
    const postfixWasModified = initialElementState.selection[1] >= initialValueBeforePostfix.length;
    const alreadyExistedValueBeforePostfix = findCommonBeginningSubstr(initialValueBeforePostfix, value);
    return {
      selection,
      value: Array.from(postfix).reverse().reduce((newValue, char, index) => {
        const i = newValue.length - 1 - index;
        const isInitiallyMirroredChar = alreadyExistedValueBeforePostfix[i] === char && postfixWasModified;
        return newValue[i] !== char || isInitiallyMirroredChar ? newValue.slice(0, i + 1) + char + newValue.slice(i + 1) : newValue;
      }, value)
    };
  } : identity;
}
function maskitoPrefixPostprocessorGenerator(prefix) {
  return prefix ? ({ value, selection }, initialElementState) => {
    if (value.startsWith(prefix) || // already valid
    !value && !initialElementState.value.startsWith(prefix)) {
      return { value, selection };
    }
    const [from2, to] = selection;
    const prefixedValue = Array.from(prefix).reduce((modifiedValue, char, i) => modifiedValue[i] === char ? modifiedValue : modifiedValue.slice(0, i) + char + modifiedValue.slice(i), value);
    const addedCharsCount = prefixedValue.length - value.length;
    return {
      selection: [from2 + addedCharsCount, to + addedCharsCount],
      value: prefixedValue
    };
  } : identity;
}
function maskitoEventHandler(name, handler, eventListenerOptions) {
  return (element, maskitoOptions) => {
    const listener = () => handler(element, maskitoOptions);
    element.addEventListener(name, listener, eventListenerOptions);
    return () => element.removeEventListener(name, listener, eventListenerOptions);
  };
}
var TRAILING_TIME_SEGMENT_SEPARATOR_REG = new RegExp(`[${TIME_FIXED_CHARACTERS.map(escapeRegExp).join("")}]$`);
function createAffixesFilterPreprocessor({ prefix, postfix }) {
  return ({ elementState, data }) => {
    const { cleanValue: cleanData } = extractAffixes(data, {
      prefix,
      postfix
    });
    return {
      elementState,
      data: cleanData
    };
  };
}
function generateMaskExpression({ decimalSeparator, isNegativeAllowed, precision, thousandSeparator, prefix, postfix, decimalPseudoSeparators = [], pseudoMinuses = [], minusSign }) {
  const computedPrefix = computeAllOptionalCharsRegExp(prefix);
  const digit = "\\d";
  const optionalMinus = isNegativeAllowed ? `[${minusSign}${pseudoMinuses.map((x) => `\\${x}`).join("")}]?` : "";
  const integerPart = thousandSeparator ? `[${digit}${escapeRegExp(thousandSeparator).replaceAll(/\s/g, "\\s")}]*` : `[${digit}]*`;
  const decimalPart = precision > 0 ? `([${escapeRegExp(decimalSeparator)}${decimalPseudoSeparators.map(escapeRegExp).join("")}]${digit}{0,${Number.isFinite(precision) ? precision : ""}})?` : "";
  const computedPostfix = computeAllOptionalCharsRegExp(postfix);
  return new RegExp(`^${computedPrefix}${optionalMinus}${integerPart}${decimalPart}${computedPostfix}$`);
}
function computeAllOptionalCharsRegExp(str) {
  return str ? `${str.split("").map((char) => `${escapeRegExp(char)}?`).join("")}` : "";
}
function maskitoParseNumber(maskedNumber, decimalSeparator = ".") {
  const hasNegativeSign = !!maskedNumber.match(new RegExp(`^\\D*[${CHAR_MINUS}\\${CHAR_HYPHEN}${CHAR_EN_DASH}${CHAR_EM_DASH}${CHAR_JP_HYPHEN}]`));
  const escapedDecimalSeparator = escapeRegExp(decimalSeparator);
  const unmaskedNumber = maskedNumber.replaceAll(new RegExp(`${escapedDecimalSeparator}(?!\\d)`, "g"), "").replaceAll(new RegExp(`[^\\d${escapedDecimalSeparator}]`, "g"), "").replace(decimalSeparator, ".");
  return unmaskedNumber ? Number((hasNegativeSign ? CHAR_HYPHEN : "") + unmaskedNumber) : NaN;
}
function stringifyNumberWithoutExp(value) {
  const valueAsString = String(value);
  const [numberPart, expPart] = valueAsString.split("e-");
  let valueWithoutExp = valueAsString;
  if (expPart) {
    const [, fractionalPart] = numberPart.split(".");
    const decimalDigits = Number(expPart) + ((fractionalPart === null || fractionalPart === void 0 ? void 0 : fractionalPart.length) || 0);
    valueWithoutExp = value.toFixed(decimalDigits);
  }
  return valueWithoutExp;
}
function toNumberParts(value, { decimalSeparator, thousandSeparator }) {
  const [integerWithMinus = "", decimalPart = ""] = value.split(decimalSeparator);
  const [, minus = "", integerPart = ""] = integerWithMinus.match(new RegExp(`([^\\d${escapeRegExp(thousandSeparator)}]+)?(.*)`)) || [];
  return { minus, integerPart, decimalPart };
}
function validateDecimalPseudoSeparators({ decimalSeparator, thousandSeparator, decimalPseudoSeparators = DEFAULT_DECIMAL_PSEUDO_SEPARATORS }) {
  return decimalPseudoSeparators.filter((char) => char !== thousandSeparator && char !== decimalSeparator);
}
function createDecimalZeroPaddingPostprocessor({ decimalSeparator, precision, decimalZeroPadding, prefix, postfix }) {
  if (precision <= 0 || !decimalZeroPadding) {
    return identity;
  }
  return ({ value, selection }) => {
    const { cleanValue, extractedPrefix, extractedPostfix } = extractAffixes(value, {
      prefix,
      postfix
    });
    if (Number.isNaN(maskitoParseNumber(cleanValue, decimalSeparator))) {
      return { value, selection };
    }
    const [integerPart, decimalPart = ""] = cleanValue.split(decimalSeparator);
    return {
      value: extractedPrefix + integerPart + decimalSeparator + decimalPart.padEnd(precision, "0") + extractedPostfix,
      selection
    };
  };
}
function emptyPostprocessor({ prefix, postfix, decimalSeparator, thousandSeparator }) {
  return ({ value, selection }) => {
    const [caretIndex] = selection;
    const { cleanValue, extractedPrefix, extractedPostfix } = extractAffixes(value, {
      prefix,
      postfix
    });
    const { minus, integerPart, decimalPart } = toNumberParts(cleanValue, {
      decimalSeparator,
      thousandSeparator
    });
    const aloneDecimalSeparator = !integerPart && !decimalPart && cleanValue.includes(decimalSeparator);
    if (!integerPart && !Number(decimalPart) && caretIndex === (minus + extractedPrefix).length || aloneDecimalSeparator) {
      return {
        selection,
        value: extractedPrefix + minus + extractedPostfix
      };
    }
    return { value, selection };
  };
}
function createInitializationOnlyPreprocessor({ decimalSeparator, decimalPseudoSeparators, pseudoMinuses, prefix, postfix, minusSign }) {
  let isInitializationPhase = true;
  const cleanNumberMask = generateMaskExpression({
    decimalSeparator,
    decimalPseudoSeparators,
    pseudoMinuses,
    prefix: "",
    postfix: "",
    thousandSeparator: "",
    precision: Infinity,
    isNegativeAllowed: true,
    minusSign
  });
  return ({ elementState, data }) => {
    if (!isInitializationPhase) {
      return { elementState, data };
    }
    isInitializationPhase = false;
    const { value, selection } = elementState;
    const [from2, to] = selection;
    const { extractedPrefix, cleanValue, extractedPostfix } = extractAffixes(value, {
      prefix,
      postfix
    });
    const cleanState = maskitoTransform({
      selection: [
        Math.max(from2 - extractedPrefix.length, 0),
        clamp(to - extractedPrefix.length, 0, cleanValue.length)
      ],
      value: cleanValue
    }, {
      mask: cleanNumberMask
    });
    const [cleanFrom, cleanTo] = cleanState.selection;
    return {
      elementState: {
        selection: [
          cleanFrom + extractedPrefix.length,
          cleanTo + extractedPrefix.length
        ],
        value: extractedPrefix + cleanState.value + extractedPostfix
      },
      data
    };
  };
}
function createLeadingZeroesValidationPostprocessor({ decimalSeparator, thousandSeparator, prefix, postfix }) {
  const trimLeadingZeroes = (value) => {
    const escapedThousandSeparator = escapeRegExp(thousandSeparator);
    return value.replace(
      // all leading zeroes followed by another zero
      new RegExp(`^(\\D+)?[0${escapedThousandSeparator}]+(?=0)`),
      "$1"
    ).replace(
      // zero followed by not-zero digit
      new RegExp(`^(\\D+)?[0${escapedThousandSeparator}]+(?=[1-9])`),
      "$1"
    );
  };
  const countTrimmedZeroesBefore = (value, index) => {
    const valueBefore = value.slice(0, index);
    const followedByZero = value.slice(index).startsWith("0");
    return valueBefore.length - trimLeadingZeroes(valueBefore).length + (followedByZero ? 1 : 0);
  };
  return ({ value, selection }) => {
    const [from2, to] = selection;
    const { cleanValue, extractedPrefix, extractedPostfix } = extractAffixes(value, {
      prefix,
      postfix
    });
    const hasDecimalSeparator = cleanValue.includes(decimalSeparator);
    const [integerPart, decimalPart = ""] = cleanValue.split(decimalSeparator);
    const zeroTrimmedIntegerPart = trimLeadingZeroes(integerPart);
    if (integerPart === zeroTrimmedIntegerPart) {
      return { value, selection };
    }
    const newFrom = from2 - countTrimmedZeroesBefore(value, from2);
    const newTo = to - countTrimmedZeroesBefore(value, to);
    return {
      value: extractedPrefix + zeroTrimmedIntegerPart + (hasDecimalSeparator ? decimalSeparator : "") + decimalPart + extractedPostfix,
      selection: [Math.max(newFrom, 0), Math.max(newTo, 0)]
    };
  };
}
function createMinMaxPostprocessor({ min, max, decimalSeparator, minusSign }) {
  return ({ value, selection }) => {
    const parsedNumber = maskitoParseNumber(value, decimalSeparator);
    const limitedValue = (
      /**
       * We cannot limit lower bound if user enters positive number.
       * The same for upper bound and negative number.
       * ___
       * @example (min = 5)
       * Empty input => Without this condition user cannot type 42 (the first digit will be rejected)
       * ___
       * @example (max = -10)
       * Value is -10 => Without this condition user cannot delete 0 to enter another digit
       */
      parsedNumber > 0 ? Math.min(parsedNumber, max) : Math.max(parsedNumber, min)
    );
    if (parsedNumber && limitedValue !== parsedNumber) {
      const newValue = `${limitedValue}`.replace(".", decimalSeparator).replace(CHAR_HYPHEN, minusSign);
      return {
        value: newValue,
        selection: [newValue.length, newValue.length]
      };
    }
    return {
      value,
      selection
    };
  };
}
function createNonRemovableCharsDeletionPreprocessor({ decimalSeparator, thousandSeparator, decimalZeroPadding }) {
  return ({ elementState, data }, actionType) => {
    const { value, selection } = elementState;
    const [from2, to] = selection;
    const selectedCharacters = value.slice(from2, to);
    const nonRemovableSeparators = decimalZeroPadding ? [decimalSeparator, thousandSeparator] : [thousandSeparator];
    const areNonRemovableZeroesSelected = decimalZeroPadding && from2 > value.indexOf(decimalSeparator) && Boolean(selectedCharacters.match(/^0+$/gi));
    if (actionType !== "deleteBackward" && actionType !== "deleteForward" || !nonRemovableSeparators.includes(selectedCharacters) && !areNonRemovableZeroesSelected) {
      return {
        elementState,
        data
      };
    }
    return {
      elementState: {
        value,
        selection: actionType === "deleteForward" ? [to, to] : [from2, from2]
      },
      data
    };
  };
}
function createNotEmptyIntegerPartPreprocessor({ decimalSeparator, precision, prefix, postfix }) {
  const startWithDecimalSepRegExp = new RegExp(`^\\D*${escapeRegExp(decimalSeparator)}`);
  return ({ elementState, data }) => {
    const { value, selection } = elementState;
    const { cleanValue, extractedPrefix } = extractAffixes(value, {
      prefix,
      postfix
    });
    const [from2, to] = selection;
    const cleanFrom = clamp(from2 - extractedPrefix.length, 0, cleanValue.length);
    const cleanTo = clamp(to - extractedPrefix.length, 0, cleanValue.length);
    if (precision <= 0 || cleanValue.slice(0, cleanFrom).includes(decimalSeparator) || cleanValue.slice(cleanTo).includes(decimalSeparator) || !data.match(startWithDecimalSepRegExp)) {
      return { elementState, data };
    }
    const digitsBeforeCursor = cleanValue.slice(0, cleanFrom).match(/\d+/);
    return {
      elementState,
      data: digitsBeforeCursor ? data : `0${data}`
    };
  };
}
function createPseudoCharactersPreprocessor({ validCharacter, pseudoCharacters, prefix, postfix }) {
  const pseudoCharactersRegExp = new RegExp(`[${pseudoCharacters.join("")}]`, "gi");
  return ({ elementState, data }) => {
    const { value, selection } = elementState;
    const { cleanValue, extractedPostfix, extractedPrefix } = extractAffixes(value, {
      prefix,
      postfix
    });
    return {
      elementState: {
        selection,
        value: extractedPrefix + cleanValue.replace(pseudoCharactersRegExp, validCharacter) + extractedPostfix
      },
      data: data.replace(pseudoCharactersRegExp, validCharacter)
    };
  };
}
function createRepeatedDecimalSeparatorPreprocessor({ decimalSeparator, prefix, postfix }) {
  return ({ elementState, data }) => {
    const { value, selection } = elementState;
    const [from2, to] = selection;
    const { cleanValue } = extractAffixes(value, { prefix, postfix });
    return {
      elementState,
      data: !cleanValue.includes(decimalSeparator) || value.slice(from2, to + 1).includes(decimalSeparator) ? data : data.replaceAll(new RegExp(escapeRegExp(decimalSeparator), "gi"), "")
    };
  };
}
function createThousandSeparatorPostprocessor({ thousandSeparator, decimalSeparator, prefix, postfix }) {
  if (!thousandSeparator) {
    return identity;
  }
  const isAllSpaces = (...chars) => chars.every((x) => /\s/.test(x));
  return ({ value, selection }) => {
    const { cleanValue, extractedPostfix, extractedPrefix } = extractAffixes(value, {
      prefix,
      postfix
    });
    const { minus, integerPart, decimalPart } = toNumberParts(cleanValue, {
      decimalSeparator,
      thousandSeparator
    });
    const [initialFrom, initialTo] = selection;
    let [from2, to] = selection;
    const processedIntegerPart = Array.from(integerPart).reduceRight((formattedValuePart, char, i) => {
      const isLeadingThousandSeparator = !i && char === thousandSeparator;
      const isPositionForSeparator = !isLeadingThousandSeparator && formattedValuePart.length && (formattedValuePart.length + 1) % 4 === 0;
      if (isPositionForSeparator && (char === thousandSeparator || isAllSpaces(char, thousandSeparator))) {
        return thousandSeparator + formattedValuePart;
      }
      if (char === thousandSeparator && !isPositionForSeparator) {
        if (i && i <= initialFrom) {
          from2--;
        }
        if (i && i <= initialTo) {
          to--;
        }
        return formattedValuePart;
      }
      if (!isPositionForSeparator) {
        return char + formattedValuePart;
      }
      if (i <= initialFrom) {
        from2++;
      }
      if (i <= initialTo) {
        to++;
      }
      return char + thousandSeparator + formattedValuePart;
    }, "");
    return {
      value: extractedPrefix + minus + processedIntegerPart + (cleanValue.includes(decimalSeparator) ? decimalSeparator : "") + decimalPart + extractedPostfix,
      selection: [from2, to]
    };
  };
}
function createZeroPrecisionPreprocessor({ precision, decimalSeparator, prefix, postfix }) {
  if (precision > 0) {
    return identity;
  }
  const decimalPartRegExp = new RegExp(`${escapeRegExp(decimalSeparator)}.*$`, "g");
  return ({ elementState, data }) => {
    const { value, selection } = elementState;
    const { cleanValue, extractedPrefix, extractedPostfix } = extractAffixes(value, {
      prefix,
      postfix
    });
    const [from2, to] = selection;
    const newValue = extractedPrefix + cleanValue.replace(decimalPartRegExp, "") + extractedPostfix;
    return {
      elementState: {
        selection: [
          Math.min(from2, newValue.length),
          Math.min(to, newValue.length)
        ],
        value: newValue
      },
      data: data.replace(decimalPartRegExp, "")
    };
  };
}
var DUMMY_SELECTION = [0, 0];
function createLeadingZeroesValidationPlugin({ decimalSeparator, thousandSeparator, prefix, postfix }) {
  const dropRepeatedLeadingZeroes = createLeadingZeroesValidationPostprocessor({
    decimalSeparator,
    thousandSeparator,
    prefix,
    postfix
  });
  return maskitoEventHandler("blur", (element) => {
    const newValue = dropRepeatedLeadingZeroes({
      value: element.value,
      selection: DUMMY_SELECTION
    }, { value: "", selection: DUMMY_SELECTION }).value;
    maskitoUpdateElement(element, newValue);
  }, { capture: true });
}
function createMinMaxPlugin({ min, max, decimalSeparator }) {
  return maskitoEventHandler("blur", (element, options) => {
    const parsedNumber = maskitoParseNumber(element.value, decimalSeparator);
    const clampedNumber = clamp(parsedNumber, min, max);
    if (!Number.isNaN(parsedNumber) && parsedNumber !== clampedNumber) {
      maskitoUpdateElement(element, maskitoTransform(stringifyNumberWithoutExp(clampedNumber), options));
    }
  }, { capture: true });
}
function createNotEmptyIntegerPlugin({ decimalSeparator, prefix, postfix }) {
  return maskitoEventHandler("blur", (element) => {
    const { cleanValue, extractedPostfix, extractedPrefix } = extractAffixes(element.value, { prefix, postfix });
    const newValue = extractedPrefix + cleanValue.replace(new RegExp(`^(\\D+)?${escapeRegExp(decimalSeparator)}`), `$10${decimalSeparator}`) + extractedPostfix;
    maskitoUpdateElement(element, newValue);
  }, { capture: true });
}
function maskitoNumberOptionsGenerator({ max = Number.MAX_SAFE_INTEGER, min = Number.MIN_SAFE_INTEGER, precision = 0, thousandSeparator = CHAR_NO_BREAK_SPACE, decimalSeparator = ".", decimalPseudoSeparators, decimalZeroPadding = false, prefix: unsafePrefix = "", postfix = "", minusSign = CHAR_MINUS } = {}) {
  const pseudoMinuses = [
    CHAR_HYPHEN,
    CHAR_EN_DASH,
    CHAR_EM_DASH,
    CHAR_JP_HYPHEN,
    CHAR_MINUS
  ].filter((char) => char !== thousandSeparator && char !== decimalSeparator && char !== minusSign);
  const validatedDecimalPseudoSeparators = validateDecimalPseudoSeparators({
    decimalSeparator,
    thousandSeparator,
    decimalPseudoSeparators
  });
  const prefix = unsafePrefix.endsWith(decimalSeparator) && precision > 0 ? `${unsafePrefix}${CHAR_ZERO_WIDTH_SPACE}` : unsafePrefix;
  return Object.assign(Object.assign({}, MASKITO_DEFAULT_OPTIONS), { mask: generateMaskExpression({
    decimalSeparator,
    precision,
    thousandSeparator,
    prefix,
    postfix,
    isNegativeAllowed: min < 0,
    minusSign
  }), preprocessors: [
    createFullWidthToHalfWidthPreprocessor(),
    createInitializationOnlyPreprocessor({
      decimalSeparator,
      decimalPseudoSeparators: validatedDecimalPseudoSeparators,
      pseudoMinuses,
      prefix,
      postfix,
      minusSign
    }),
    createAffixesFilterPreprocessor({ prefix, postfix }),
    createPseudoCharactersPreprocessor({
      validCharacter: minusSign,
      pseudoCharacters: pseudoMinuses,
      prefix,
      postfix
    }),
    createPseudoCharactersPreprocessor({
      validCharacter: decimalSeparator,
      pseudoCharacters: validatedDecimalPseudoSeparators,
      prefix,
      postfix
    }),
    createNotEmptyIntegerPartPreprocessor({
      decimalSeparator,
      precision,
      prefix,
      postfix
    }),
    createNonRemovableCharsDeletionPreprocessor({
      decimalSeparator,
      decimalZeroPadding,
      thousandSeparator
    }),
    createZeroPrecisionPreprocessor({
      precision,
      decimalSeparator,
      prefix,
      postfix
    }),
    createRepeatedDecimalSeparatorPreprocessor({
      decimalSeparator,
      prefix,
      postfix
    })
  ], postprocessors: [
    createMinMaxPostprocessor({ decimalSeparator, min, max, minusSign }),
    maskitoPrefixPostprocessorGenerator(prefix),
    maskitoPostfixPostprocessorGenerator(postfix),
    createThousandSeparatorPostprocessor({
      decimalSeparator,
      thousandSeparator,
      prefix,
      postfix
    }),
    createDecimalZeroPaddingPostprocessor({
      decimalSeparator,
      decimalZeroPadding,
      precision,
      prefix,
      postfix
    }),
    emptyPostprocessor({ prefix, postfix, decimalSeparator, thousandSeparator })
  ], plugins: [
    createLeadingZeroesValidationPlugin({
      decimalSeparator,
      thousandSeparator,
      prefix,
      postfix
    }),
    createNotEmptyIntegerPlugin({
      decimalSeparator,
      prefix,
      postfix
    }),
    createMinMaxPlugin({ min, max, decimalSeparator })
  ], overwriteMode: decimalZeroPadding ? ({ value, selection: [from2] }) => from2 <= value.indexOf(decimalSeparator) ? "shift" : "replace" : "shift" });
}

// libs/widgets/src/lib/swap-form/elements/input/input.element.ts
import "@one-inch-community/widgets/token-icon";
import "@one-inch-community/ui-components/icon";
import "@one-inch-community/ui-components/button";
import { formatNumber as formatNumber2 } from "@one-inch-community/core/formatters";

// libs/widgets/src/lib/swap-form/elements/balance/balance.element.ts
import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { consume } from "@lit/context";

// libs/widgets/src/lib/swap-form/elements/balance/balance.styles.ts
import { mobileMediaCSS } from "@one-inch-community/core/lit";
import { css as css2 } from "lit";
var balanceStyles = css2`

    :host {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0;
        text-align: right;
        width: fit-content;
        color: var(--color-content-content-secondary);
    }

    ${mobileMediaCSS(css2`
        :host {
            font-size: 13px;
        }
    `)}
`;

// libs/widgets/src/lib/swap-form/elements/balance/balance.element.ts
import { combineLatest, defer, filter, startWith, switchMap } from "rxjs";
import { formatUnits } from "viem";
import { observe, translate } from "@one-inch-community/core/lit";
import { getBlockEmitter } from "@one-inch-community/sdk/chain";
import { formatNumber } from "@one-inch-community/core/formatters";
import { SwapContextToken } from "@one-inch-community/sdk/swap";
import { ApplicationContextToken } from "@one-inch-community/core/application-context";
var BalanceElement = class extends LitElement {
  constructor() {
    super(...arguments);
    this.balance$ = defer(() => {
      if (!this.context) throw new Error("");
      if (!this.tokenType) throw new Error("");
      return combineLatest([
        this.context.connectedWalletAddress$,
        this.context.getTokenByType(this.tokenType),
        this.context.chainId$,
        this.context.chainId$.pipe(
          switchMap((chainId) => chainId ? getBlockEmitter(chainId) : []),
          startWith(null)
        )
      ]);
    }).pipe(
      filter(([address]) => !!address),
      switchMap(async ([walletAddress, token, chainId]) => {
        if (!walletAddress || !token || !chainId) return html`<br>`;
        const balanceRecord = await this.applicationContext.tokenController.getTokenBalance(chainId, token.address, walletAddress);
        if (!balanceRecord) return html`<br>`;
        const balance = formatNumber(formatUnits(BigInt(balanceRecord.amount), token.decimals), 6);
        return this.getBalanceView(balance);
      })
    );
  }
  render() {
    return html`${observe(this.balance$, html`<br>`)}`;
  }
  getBalanceView(balance) {
    return html`
      <span>${translate("widgets.swap-form.input.balance.balance")}: ${balance}</span>
    `;
  }
};
BalanceElement.tagName = "inch-swap-balance";
BalanceElement.styles = balanceStyles;
__decorateClass([
  property({ type: String, attribute: true })
], BalanceElement.prototype, "tokenType", 2);
__decorateClass([
  consume({ context: SwapContextToken })
], BalanceElement.prototype, "context", 2);
__decorateClass([
  consume({ context: ApplicationContextToken })
], BalanceElement.prototype, "applicationContext", 2);
BalanceElement = __decorateClass([
  customElement(BalanceElement.tagName)
], BalanceElement);

// libs/widgets/src/lib/swap-form/elements/fiat-balance/fiat-balance.element.ts
import { html as html2, LitElement as LitElement2 } from "lit";
import { customElement as customElement2, property as property2 } from "lit/decorators.js";
import { consume as consume2 } from "@lit/context";
import { observe as observe2 } from "@one-inch-community/core/lit";
import { catchError as catchError2, combineLatest as combineLatest2, defer as defer2, filter as filter2, map as map2, switchMap as switchMap2 } from "rxjs";
import { formatUnits as formatUnits2 } from "viem";
import { smartFormatNumber } from "@one-inch-community/core/formatters";

// libs/widgets/src/lib/swap-form/elements/fiat-balance/fiat-balance.styles.ts
import { mobileMediaCSS as mobileMediaCSS2 } from "@one-inch-community/core/lit";
import { css as css3 } from "lit";
var fiatBalanceStyles = css3`

    :host {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0;
        text-align: right;
        color: var(--color-content-content-secondary);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    ${mobileMediaCSS2(css3`
        :host {
            font-size: 13px;
        }
    `)}

`;

// libs/widgets/src/lib/swap-form/elements/fiat-balance/fiat-balance.element.ts
import { SwapContextToken as SwapContextToken2 } from "@one-inch-community/sdk/swap";
import { ApplicationContextToken as ApplicationContextToken2 } from "@one-inch-community/core/application-context";
var FiatBalanceElement = class extends LitElement2 {
  constructor() {
    super(...arguments);
    this.balance$ = defer2(() => {
      if (!this.context) throw new Error("");
      if (!this.tokenType) throw new Error("");
      return combineLatest2([
        this.context.connectedWalletAddress$,
        this.context.getTokenByType(this.tokenType),
        this.context.chainId$
      ]);
    }).pipe(
      filter2(([address]) => !!address),
      switchMap2(([walletAddress, token, chainId]) => {
        if (!walletAddress || !token || !chainId) return [html2`<br>`];
        return combineLatest2([
          this.applicationContext.tokenController.liveQuery(() => this.applicationContext.tokenController.getTokenUSDPrice(chainId, token.address)),
          this.context.getTokenRawAmountByType(this.tokenType)
        ]).pipe(
          map2(([tokenPrice, amount]) => {
            if (!amount) return html2`<br>`;
            const balanceFormatted = formatUnits2(BigInt(amount), token.decimals);
            const balanceUsd = Number(balanceFormatted) * Number(tokenPrice);
            return this.getBalanceView(smartFormatNumber(balanceUsd.toString(), 1));
          }),
          catchError2(() => [html2`<br>`])
        );
      })
    );
  }
  render() {
    return html2`${observe2(this.balance$, html2`<br>`)}`;
  }
  getBalanceView(balance) {
    return html2`
      <span>~$${balance}</span>
    `;
  }
};
FiatBalanceElement.tagName = "inch-fiat-balance";
FiatBalanceElement.styles = fiatBalanceStyles;
__decorateClass([
  property2({ type: String, attribute: true })
], FiatBalanceElement.prototype, "tokenType", 2);
__decorateClass([
  consume2({ context: SwapContextToken2 })
], FiatBalanceElement.prototype, "context", 2);
__decorateClass([
  consume2({ context: ApplicationContextToken2 })
], FiatBalanceElement.prototype, "applicationContext", 2);
FiatBalanceElement = __decorateClass([
  customElement2(FiatBalanceElement.tagName)
], FiatBalanceElement);

// libs/widgets/src/lib/swap-form/elements/input/input.style.ts
import { mobileMediaCSS as mobileMediaCSS3 } from "@one-inch-community/core/lit";
import { css as css4 } from "lit";
var inputStyle = css4`

    .input-container {
        height: 128px;
        border-radius: 16px;
        background-color: var(--color-background-bg-secondary);
        transition: box-shadow .2s;
        padding: 16px;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: minmax(40%, auto) minmax(auto, 70%);
        justify-content: space-between;
    }

    .input-container.disabled {
        background-color: var(--color-background-bg-primary);
        border: 1px solid var(--color-border-border-tertiary);
    }
    
    .flex-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
    }
    
    .input-title {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0;
        text-align: left;
        color: var(--color-content-content-secondary);
        width: fit-content;
    }

    .symbol-container {
        border: none;
        background-color: transparent;
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        color: var(--color-content-content-primary);
        border-radius: 16px;
        padding: 8px;
        margin-left: -8px;
        transition: background-color .2s;
        outline: none;
        user-select: none;
        width: fit-content;
        -webkit-tap-highlight-color: transparent;
    }

    .symbol-container_disabled {
        cursor: auto;
    }
    
    .symbol {
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
        letter-spacing: 0;
        text-align: left;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    
    .token-name {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0;
        text-align: left;
        color: var(--color-content-content-secondary);
        font-style: normal;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .token-name:dir(rtl) {
        text-align: right;
    }
    
    .amount-input {
        height: 48px;
        padding: 0;
        color: var(--color-content-content-primary);
        box-sizing: border-box;
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
        letter-spacing: 0;
        text-align: right;
        border: none;
        background-color: transparent;
        outline: none;
        user-select: none;
        width: 100%;
    }
    
    .input-rtl {
        text-align: left; 
    }

    .amount-input[type="number"]::-webkit-inner-spin-button,
    .amount-input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .amount-input[type="number"] {
        -moz-appearance: textfield;
    }
    .amount-input:disabled {
        opacity: 1;
        color: var(--color-content-content-primary);
    }
    
    .balance-amount-fiat {
        align-items: flex-end;
    }
    
    .focus:not(.disabled) {
        box-shadow: inset 0 0 0 1px var(--primary-50);
    }
    
    .balance-and-max {
        display: flex;
        gap: 8px;
        align-items: center;
    }
    
    .loading {
        will-change: opacity;
        animation: stub-loader-animation 2s ease-in-out infinite;
    }
    
    .input-rtl {
        text-align: end;
    }

    @keyframes stub-loader-animation {
        0%, 100% {
            opacity: 1;
        }
        50% {
            opacity: 0.5;
        }
    }
    
    @media (hover: hover) {
        .input-container:not(.disabled):not(.focus):hover {
            box-shadow: inset 0 0 0 1px var(--primary-12);
        }
        .symbol-container:not(.symbol-container_disabled):hover {
            background-color: var(--color-background-bg-positive-hover);
        }
    }

    ${mobileMediaCSS3(css4`
        .amount-input {
            height: 40px;
        }
        .symbol, .amount-input {
            font-size: 20px;
        }
        .input-title, .token-name {
            font-size: 13px;
        }
        .input-container {
            height: 116px;
        }
        .symbol-container {
            padding: 4px 8px;
        }
    `)}
    
    .symbol-container:not(.symbol-container_disabled):active {
        transform: scale(.98);
        background-color: var(--color-background-bg-positive-hover);
    }
    
    .select-token-text {
        word-wrap: break-word;
        white-space: nowrap
    }

`;

// libs/widgets/src/lib/swap-form/elements/input/input.element.ts
import { observe as observe3, subscribe, dispatchEvent, translate as translate2, isRTLCurrentLocale, localeChange$ } from "@one-inch-community/core/lit";
import { formatUnits as formatUnits3, parseUnits } from "viem";
import { when } from "lit/directives/when.js";
import { choose } from "lit/directives/choose.js";
import { SwapContextToken as SwapContextToken3 } from "@one-inch-community/sdk/swap";
import { EmbeddedConfigToken } from "@one-inch-community/core/application-context";
var InputElement = class extends LitElement3 {
  constructor() {
    super(...arguments);
    this.disabled = false;
    this.isFocus = false;
    this.connectedAddress = null;
    this.setMaxInProgress = false;
    this.token = null;
    this.token$ = defer3(() => this.getTokenEventEmitter()).pipe(
      shareReplay({ bufferSize: 1, refCount: true })
    );
    this.chainId$ = defer3(() => this.getChainEventEmitter());
    this.connectedAddress$ = defer3(() => this.getConnectedWalletAddress());
    this.amount$ = defer3(() => this.getTokenAmountStream());
    this.loading$ = defer3(() => this.getLoadingStream());
    this.loaderView$ = defer3(() => this.loading$.pipe(
      // map(() => true),
      map3((state4) => {
        if (this.tokenType === "source") return html3`${this.input}`;
        if (state4) return html3`<span class="loader"></span>`;
        return html3`${this.input}`;
      }),
      startWith2(html3`${this.input}`)
    ));
    this.input = document.createElement("input");
    this.maskedInput = this.buildMask(6);
    this.tokenView$ = this.token$.pipe(
      map3((token) => {
        if (!token) return this.selectTokenView();
        return this.tokenView(token);
      })
    );
  }
  connectedCallback() {
    super.connectedCallback();
    this.input.classList.add("amount-input");
    this.input.inputMode = "decimal";
    this.input.autocomplete = "off";
    this.input.placeholder = this.tokenType === "source" ? "0" : "";
    this.input.onfocus = () => this.onFocus();
    this.input.onblur = () => this.onBlur();
    this.input.oninput = (event) => this.onInput(event);
    const updateMask$ = this.token$.pipe(
      tap((token) => {
        if (!token) return;
        this.maskedInput.destroy();
        this.maskedInput = this.buildMask(token.decimals);
      })
    );
    const loading$ = this.loading$.pipe(
      switchMap3((state4) => {
        if (this.tokenType === "source") return of(void 0);
        if (state4 && !this.input.classList.contains("loading")) {
          this.input.classList.add("loading");
          return of(void 0);
        }
        if (!state4 && this.input.classList.contains("loading")) {
          return from(this.input.animate([
            {},
            { opacity: 1 }
          ], { duration: 2e3 }).finished.then(() => {
            this.input.classList.remove("loading");
          }));
        }
        return of(void 0);
      })
    );
    const updateInputValue$ = combineLatest3([
      this.amount$,
      this.token$
    ]).pipe(
      map3(([amount, token]) => {
        if (!amount || !token) return "0";
        return formatUnits3(amount, token.decimals);
      }),
      filter3((amount, index) => {
        if (index === 0 && amount === "0") return false;
        return amount !== this.input.value;
      }),
      tap((amount) => this.input.value = formatNumber2(amount, 6))
    );
    subscribe(this, [
      updateMask$,
      updateInputValue$,
      loading$,
      this.token$.pipe(tap((token) => this.token = token)),
      this.connectedAddress$.pipe(tap((address) => this.connectedAddress = address))
    ], { requestUpdate: false });
    subscribe(this, [
      localeChange$
    ]);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.maskedInput.destroy();
  }
  render() {
    const classes = {
      disabled: this.disabled,
      focus: this.isFocus
    };
    this.input.disabled = this.tokenType === "destination";
    this.updateInputRtl();
    return html3`
      <div class="input-container ${classMap(classes)}">
        <div class="flex-container symbol-title-name">
          <div class="input-title">${choose(this.tokenType, [
      ["source", () => html3`${translate2("widgets.swap-form.input.title.you_pay")}`],
      ["destination", () => html3`${translate2("widgets.swap-form.input.title.you_receive")}`]
    ])}</div>
          ${observe3(this.tokenView$)}
        </div>
        
        <div class="flex-container balance-amount-fiat">
          <div class="balance-and-max">
            <inch-swap-balance tokenType="${ifDefined(this.tokenType)}"></inch-swap-balance>
            ${when(this.connectedAddress && this.token && this.tokenType === "source", () => html3`
              <inch-button @click="${async () => {
      this.setMaxInProgress = true;
      await this.context?.setMaxAmount();
      this.setMaxInProgress = false;
    }}" type="secondary" size="xs" loader="${ifDefined(this.setMaxInProgress ? "" : void 0)}">MAX</inch-button>
            `)}
          </div>
          ${this.input}
          <inch-fiat-balance tokenType="${ifDefined(this.tokenType)}"></inch-fiat-balance>
        </div>
      </div>
    `;
  }
  selectTokenView() {
    return html3`
      <inch-button disabledSlotPointerEvent type="secondary" size="l" @click="${(event) => dispatchEvent(this, "openTokenSelector", this.tokenType, event)}">
        <span class="select-token-text">Select token</span>
        <inch-icon icon="chevronDown16"></inch-icon>
      </inch-button>
      <br>
    `;
  }
  onFocus() {
    this.isFocus = true;
    dispatchEvent(this, "focusTokenInput", this.tokenType);
  }
  onBlur() {
    this.isFocus = false;
    dispatchEvent(this, "blurTokenInput", this.tokenType);
  }
  tokenView(token) {
    const { name, symbol, address } = token;
    const classes = {
      "symbol-container": true,
      "symbol-container_disabled": this.config?.swapFromParams.disabledTokenChanging ?? false
    };
    return html3`
      <button @click="${(event) => this.openTokenSelector(event)}"
              class="${classMap(classes)}">
        <inch-token-icon
          symbol="${symbol}"
          address="${address}"
          chainId="${observe3(this.chainId$)}"
        ></inch-token-icon>
        <span class="symbol">${symbol}</span>
        ${when(!this.config?.swapFromParams.disabledTokenChanging, () => html3`<inch-icon icon="chevronDown16"></inch-icon>`)}
      </button>
      <div class="token-name">${name}</div>
    `;
  }
  openTokenSelector(event) {
    if (this.config?.swapFromParams.disabledTokenChanging) return;
    dispatchEvent(this, "openTokenSelector", this.tokenType, event);
  }
  updateInputRtl() {
    if (isRTLCurrentLocale() && !this.input.classList.contains("input-rtl")) {
      this.input.classList.add("input-rtl");
    }
    if (!isRTLCurrentLocale() && this.input.classList.contains("input-rtl")) {
      this.input.classList.remove("input-rtl");
    }
  }
  getTokenEventEmitter() {
    if (!this.context) throw new Error("");
    if (!this.tokenType) throw new Error("");
    return this.context.getTokenByType(this.tokenType);
  }
  getTokenAmountStream() {
    if (!this.context) throw new Error("");
    if (!this.tokenType) throw new Error("");
    return this.context.getTokenAmountByType(this.tokenType);
  }
  getLoadingStream() {
    if (!this.context) throw new Error("");
    if (!this.tokenType) throw new Error("");
    return this.context.loading$;
  }
  getChainEventEmitter() {
    if (!this.context) throw new Error("");
    return this.context.chainId$;
  }
  getConnectedWalletAddress() {
    if (!this.context) throw new Error("");
    return this.context.connectedWalletAddress$;
  }
  onInput(event) {
    if (!this.tokenType) return;
    const target = event.target;
    const valueString = target?.value ?? "";
    const token = this.token;
    if (!token) return;
    const amount = parseUnits(valueString.replaceAll("\xA0", ""), token.decimals);
    this.context?.setTokenAmountByType(this.tokenType, amount);
  }
  buildMask(decimals) {
    return new Maskito(this.input, maskitoNumberOptionsGenerator({
      precision: decimals,
      max: 9 * 10 ** 15,
      min: 0
    }));
  }
};
InputElement.tagName = "inch-swap-form-input";
InputElement.styles = inputStyle;
__decorateClass([
  property3({ type: Boolean, attribute: true, reflect: true })
], InputElement.prototype, "disabled", 2);
__decorateClass([
  property3({ type: String, attribute: true, reflect: true })
], InputElement.prototype, "tokenType", 2);
__decorateClass([
  state()
], InputElement.prototype, "isFocus", 2);
__decorateClass([
  state()
], InputElement.prototype, "connectedAddress", 2);
__decorateClass([
  state()
], InputElement.prototype, "setMaxInProgress", 2);
__decorateClass([
  consume3({ context: SwapContextToken3 })
], InputElement.prototype, "context", 2);
__decorateClass([
  consume3({ context: EmbeddedConfigToken })
], InputElement.prototype, "config", 2);
InputElement = __decorateClass([
  customElement3(InputElement.tagName)
], InputElement);

// libs/widgets/src/lib/swap-form/elements/token-pair-switch/token-pair-switch.element.ts
import { html as html4, LitElement as LitElement4 } from "lit";
import { customElement as customElement4 } from "lit/decorators.js";
import { ref, createRef } from "lit/directives/ref.js";
import { consume as consume4 } from "@lit/context";
import { combineLatest as combineLatest4, defer as defer4, fromEvent, map as map4, switchMap as switchMap4 } from "rxjs";
import "@one-inch-community/ui-components/icon";
import { observe as observe4, subscribe as subscribe2, appendStyle, getMobileMatchMedia } from "@one-inch-community/core/lit";

// libs/widgets/src/lib/swap-form/elements/token-pair-switch/token-pair-switch.style.ts
import { css as css5 } from "lit";
var tokenPairSwitchStyle = css5`

    :host {
        height: 4px;
        position: relative;
        outline: none;
        user-select: none;
        display: flex;
        align-items: center;
        justify-content: center;
        -webkit-tap-highlight-color: transparent;
    }
    
    .switcher {
        position: absolute;
        border-radius: 50%;
        border: none;
        background-color: var(--color-background-bg-primary);
        color: var(--color-content-content-primary);
        box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.12), 0 1px 4px 0 rgba(0, 0, 0, 0.12);
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        top: -13px;
        cursor: pointer;
        will-change: transform;
    }
    
    .switcher:disabled {
        cursor: not-allowed;
        pointer-events: none;
        color: var(--color-content-content-disabled);
        box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.12), 0 1px 4px 0 rgba(0, 0, 0, 0.12);
    }
    
    @media (hover: hover) {
        .switcher:not(:disabled):hover {
            color: var(--color-content-content-secondary);
        }
    }
`;

// libs/widgets/src/lib/swap-form/elements/token-pair-switch/token-pair-switch.element.ts
import { SwapContextToken as SwapContextToken4 } from "@one-inch-community/sdk/swap";
import { EmbeddedConfigToken as EmbeddedConfigToken2 } from "@one-inch-community/core/application-context";
var TokenPairSwitchElement = class extends LitElement4 {
  constructor() {
    super(...arguments);
    this.iconRef = createRef();
    this.buttonRef = createRef();
    this.mobileMedia = getMobileMatchMedia();
    this.isUp = false;
    this.isDisabled$ = defer4(() => {
      if (!this.context) throw new Error("");
      return combineLatest4([
        this.context.getTokenByType("source"),
        this.context.getTokenByType("destination")
      ]);
    }).pipe(
      map4(
        ([sourceToken, destinationToken]) => !sourceToken || !destinationToken || this.config?.swapFromParams.disabledTokenChanging
      )
    );
  }
  firstUpdated() {
    if (!this.buttonRef.value) return;
    if (this.config?.swapFromParams.disabledTokenChanging) return;
    if (!this.mobileMedia.matches) {
      const options = {
        duration: 200,
        easing: "cubic-bezier(.1, .3, .6, 1)"
      };
      subscribe2(this, [
        fromEvent(this.buttonRef.value, "mouseenter").pipe(
          switchMap4(async () => {
            if (!this.iconRef.value || this.isUp) return;
            this.isUp = true;
            await this.iconRef.value.animate([
              { transform: "rotate(0deg)" },
              { transform: "rotate(180deg)" }
            ], options).finished;
            appendStyle(this.iconRef.value, {
              transform: "rotate(180deg)"
            });
          })
        ),
        fromEvent(this.buttonRef.value, "mouseleave").pipe(
          switchMap4(async () => {
            if (!this.iconRef.value || !this.isUp) return;
            this.isUp = false;
            await this.iconRef.value.animate([
              { transform: "rotate(180deg)" },
              { transform: "rotate(360deg)" }
            ], options).finished;
            appendStyle(this.iconRef.value, {
              transform: ""
            });
          })
        )
      ]);
    }
  }
  render() {
    return html4`
      <button
        ${ref(this.buttonRef)}
        @click="${() => this.onClick()}"
        ?disabled="${observe4(this.isDisabled$, false)}"
        class="switcher"
      >
        <inch-icon ${ref(this.iconRef)} class="switcher-icon" icon="arrowDown24"></inch-icon>
      </button>
    `;
  }
  async onClick() {
    if (this.config?.swapFromParams.disabledTokenChanging) return;
    if (!this.iconRef.value || !this.isUp && !this.mobileMedia.matches) return;
    this.context?.switchPair();
    const options = {
      duration: 200,
      easing: "cubic-bezier(.1, .3, .6, 1)"
    };
    if (!this.mobileMedia.matches) {
      await this.iconRef.value.animate([
        { transform: "rotate(180deg)" },
        { transform: "rotate(360deg)" }
      ], options).finished;
      appendStyle(this.iconRef.value, {
        transform: ""
      });
      this.isUp = false;
    }
  }
};
TokenPairSwitchElement.tagName = "inch-token-pair-switch";
TokenPairSwitchElement.styles = tokenPairSwitchStyle;
__decorateClass([
  consume4({ context: SwapContextToken4 })
], TokenPairSwitchElement.prototype, "context", 2);
__decorateClass([
  consume4({ context: EmbeddedConfigToken2 })
], TokenPairSwitchElement.prototype, "config", 2);
TokenPairSwitchElement = __decorateClass([
  customElement4(TokenPairSwitchElement.tagName)
], TokenPairSwitchElement);

// libs/widgets/src/lib/swap-form/elements/swap-button/swap-button.element.ts
import { html as html5, LitElement as LitElement5 } from "lit";
import { customElement as customElement5, state as state2 } from "lit/decorators.js";
import { ifDefined as ifDefined2 } from "lit/directives/if-defined.js";
import "@one-inch-community/ui-components/button";
import { consume as consume5 } from "@lit/context";
import { BrandColors } from "@one-inch-community/models";
import {
  combineLatest as combineLatest5,
  debounceTime,
  defer as defer5,
  distinctUntilChanged,
  firstValueFrom,
  map as map5,
  of as of2,
  startWith as startWith3,
  switchMap as switchMap5,
  tap as tap3,
  merge,
  withLatestFrom,
  Subject,
  shareReplay as shareReplay2
} from "rxjs";
import {
  dispatchEvent as dispatchEvent3,
  getMobileMatchMediaAndSubscribe,
  subscribe as subscribe3,
  translate as translate3
} from "@one-inch-community/core/lit";
import {
  getAllowance,
  getBlockEmitter as getBlockEmitter2,
  getOneInchRouterV6ContractAddress,
  hasPermit,
  isChainId,
  isNativeToken,
  isSupportPermit2,
  waitTransaction
} from "@one-inch-community/sdk/chain";
import { getThemeChange } from "@one-inch-community/core/theme";

// libs/widgets/src/lib/swap-form/elements/swap-button/swap-button.style.ts
import { mobileMediaCSS as mobileMediaCSS4 } from "@one-inch-community/core/lit";
import { getRainbowGradient } from "@one-inch-community/core/theme";
import { css as css6 } from "lit";
var swapButtonStyle = css6`
      :host {
          height: 57px;
      }

      ${mobileMediaCSS4(css6`
          :host {
              height: 44px;
          }
      `)}
      .smart-hover {
          position: relative;
          overflow: hidden;
      }
      .on-hover,
      .off-hover {
          position: absolute;
          transition: transform .2s;
      }
      
      .on-hover {
          transform: translateY(-200%);
      }

      .rainbow {
          --button-text-color-ext: #ffffff;
          --button-text-color-ext-hover: #ffffff;
          position: relative;
      }

      .rainbow:after, .rainbow:before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background: ${getRainbowGradient()};
          background-size: 1000%;
          animation: bg-rainbow 300s cubic-bezier(0.4, 0, 1, 1) infinite;
          z-index: -1;
      }

      @keyframes bg-rainbow {
          0% {
              border-radius: 24px;
              background-position: 0 0;
          }
          50% {
              border-radius: 24px;
              background-size: 800%;
              background-position: 400% 0;
          }
          100% {
              border-radius: 24px;
              background-position: 0 0;
          }
      }
      @media (hover: hover) {
          .smart-hover:hover .on-hover {
              transform: translateY(0);
          }

          .smart-hover:hover .off-hover {
              transform: translateY(200%);
          }
      }
      @media (hover: none) {
          .smart-hover .on-hover {
              transform: translateY(0);
          }

          .smart-hover .off-hover {
              transform: translateY(200%);
          }
      }

  `;

// libs/widgets/src/lib/swap-form/elements/swap-button/swap-button.element.ts
import { when as when2 } from "lit/directives/when.js";
import { JsonParser, storage } from "@one-inch-community/core/storage";
import { CacheActivePromise } from "@one-inch-community/core/decorators";
import { SwapContextToken as SwapContextToken5 } from "@one-inch-community/sdk/swap";
import { ApplicationContextToken as ApplicationContextToken3 } from "@one-inch-community/core/application-context";
import { isTokensEqual } from "@one-inch-community/sdk/tokens";
import { getEnvironmentValue } from "@one-inch-community/core/environment";
import { isAddress } from "viem";
var showLoader = [
  1 /* readyToSwapLoading */,
  9 /* checkAllowance */,
  17 /* checkAllowanceForHolder */,
  15 /* permitInWallet */,
  16 /* approveInWallet */,
  20 /* approveInWalletForHolder */,
  13 /* updateSwapData */,
  14 /* waitingApproveTransaction */,
  19 /* waitingApproveTransactionForHolder */
];
var SwapButtonElement = class extends LitElement5 {
  constructor() {
    super(...arguments);
    this.isRainbowTheme = false;
    this.buttonState = storage.get("fusion_swap_button_state", JsonParser) ?? 0 /* readyToSwap */;
    this.chainId = null;
    this.srcToken = null;
    this.lastHolderCheckToken = null;
    this.lastRouterCheckToken = null;
    this.mobileMedia = getMobileMatchMediaAndSubscribe(this);
    this.connectedWalletAddress$ = defer5(() => this.getConnectedWalletAddress());
    this.sourceToken$ = defer5(() => this.getSourceToken());
    this.destinationToken$ = defer5(() => this.getDestinationToken());
    this.chainId$ = defer5(() => this.getChainId());
    this.sourceTokenAmount$ = defer5(() => this.getSourceTokenAmount());
    this.rate$ = defer5(() => this.getRate());
    this.loading$ = defer5(() => this.getLoading());
    this.block$ = this.chainId$.pipe(
      switchMap5((chainId) => chainId ? getBlockEmitter2(chainId) : of2(null))
    );
    this.updateView$ = new Subject();
    this.approvalHolder = (() => {
      const value = getEnvironmentValue("approvalHolder");
      if (!value || !isAddress(value)) {
        console.warn("approvalHolder is not set or invalid in environment, using default");
        return "0x0000000000000000000000000000000000000000";
      }
      return value;
    })();
    this.exceedingMaximumAmount$ = combineLatest5([
      this.connectedWalletAddress$,
      this.sourceToken$,
      this.sourceTokenAmount$.pipe(startWith3(0n)),
      merge(this.chainId$, this.block$).pipe(startWith3(null))
    ]).pipe(
      switchMap5(([wallet, sourceToken, amount]) => {
        if (!wallet || !sourceToken || amount === 0n || !this.context || !isAddress(wallet) || !isAddress(sourceToken.address)) return of2(false);
        return this.context.getMaxAmount().then((balance) => {
          if (balance === 0n) return true;
          return !amount || amount > balance;
        }).catch(() => of2(false));
      }),
      shareReplay2({ bufferSize: 1, refCount: true })
    );
    this.calculateStatus$ = combineLatest5([
      this.connectedWalletAddress$,
      this.sourceToken$,
      this.destinationToken$,
      this.exceedingMaximumAmount$,
      this.sourceTokenAmount$.pipe(startWith3(0n)),
      this.chainId$,
      this.rate$.pipe(startWith3(null)),
      this.loading$,
      merge(this.block$, this.updateView$).pipe(startWith3(null))
    ]).pipe(
      map5((params, index) => {
        const [
          walletAddress,
          srcToken,
          dstToken,
          exceedingMaximumAmount,
          amount,
          chainId,
          rate,
          loading
        ] = params;
        this.chainId = chainId;
        this.srcToken = srcToken;
        if (!chainId || !isChainId(chainId)) {
          return 2 /* unsupportedChain */;
        }
        if (!walletAddress || !isAddress(walletAddress)) {
          return 3 /* walletNotConnected */;
        }
        if (!srcToken || !isAddress(srcToken.address)) {
          return 4 /* unselectedSourceToken */;
        }
        if (!dstToken) {
          return 5 /* unselectedDestinationToken */;
        }
        if (!amount || amount === 0n) {
          return 6 /* zeroAmount */;
        }
        if (exceedingMaximumAmount) {
          return 7 /* exceedingMaximumAmount */;
        }
        if (loading && (index === 0 || rate === null)) {
          return 13 /* updateSwapData */;
        }
        if (rate === null) {
          return 8 /* rateNotExist */;
        }
        if (isNativeToken(srcToken.address)) {
          return 12 /* wrapNativeToken */;
        }
        if (this.isNeedCheckAllowanceForHolder()) {
          return 17 /* checkAllowanceForHolder */;
        }
        if (this.isNeedCheckAllowanceForRouter()) {
          return 9 /* checkAllowance */;
        }
        return 0 /* readyToSwap */;
      }),
      debounceTime(0),
      withLatestFrom(this.chainId$, this.connectedWalletAddress$, this.sourceToken$),
      switchMap5(async ([state4, chainId, walletAddress, srcToken]) => {
        if (!chainId || !isChainId(chainId)) return 2 /* unsupportedChain */;
        if (!walletAddress || !isAddress(walletAddress)) return 3 /* walletNotConnected */;
        if (!srcToken || !isAddress(srcToken.address)) return 4 /* unselectedSourceToken */;
        if (state4 === 17 /* checkAllowanceForHolder */) {
          const holder = this.approvalHolder;
          if (!holder || !isAddress(holder)) {
            console.warn("Skipping holder allowance check due to invalid approvalHolder:", holder);
            return 9 /* checkAllowance */;
          }
          const allowance = await getAllowance(chainId, srcToken.address, walletAddress, holder);
          const amount = await firstValueFrom(this.sourceTokenAmount$);
          if (amount && allowance < amount) {
            return 18 /* lowAllowanceNeedApproveForHolder */;
          }
          this.lastHolderCheckToken = srcToken;
          return 9 /* checkAllowance */;
        }
        if (state4 === 9 /* checkAllowance */) {
          const contract = getOneInchRouterV6ContractAddress(chainId);
          const allowance = await getAllowance(chainId, srcToken.address, walletAddress, contract);
          const amount = await firstValueFrom(this.sourceTokenAmount$);
          if (amount && allowance < amount) {
            if (isSupportPermit2(chainId)) {
              const isHasPermit = await hasPermit(chainId, srcToken.address, walletAddress, contract);
              if (isHasPermit) {
                this.lastRouterCheckToken = srcToken;
                return 0 /* readyToSwap */;
              }
              return 11 /* lowAllowanceNeedPermit */;
            }
            return 10 /* lowAllowanceNeedApprove */;
          }
          this.lastRouterCheckToken = srcToken;
          return 0 /* readyToSwap */;
        }
        return state4;
      }),
      tap3((state4) => {
        this.buttonState = state4;
        storage.set("fusion_swap_button_state", this.buttonState);
      }),
      shareReplay2({ bufferSize: 1, refCount: true })
    );
  }
  connectedCallback() {
    super.connectedCallback();
    subscribe3(this, [
      getThemeChange().pipe(
        map5(({ brandColor }) => brandColor),
        distinctUntilChanged(),
        tap3((color) => this.isRainbowTheme = color === BrandColors.rainbow)
      ),
      this.sourceToken$.pipe(tap3((token) => this.srcToken = token)),
      this.calculateStatus$
    ]);
    setTimeout(() => this.updateView$.next(), 100);
  }
  render() {
    const size = this.mobileMedia.matches ? "xl" : "xxl";
    return html5`
      <inch-button
        class="smart-hover"
        @click="${(event) => this.onClickSwapButton(event)}"
        type="${this.getButtonType()}"
        size="${size}"
        loader="${ifDefined2(this.getLoaderState())}"
        fullSize
      >
        ${when2(this.buttonState === 2 /* unsupportedChain */, () => html5`
          <span class="off-hover">Chain ${this.chainId} not supported</span>
          <span class="on-hover">Change chain</span>
          <br>
        `)}
        ${when2(this.buttonState === 13 /* updateSwapData */, () => html5`<span>${translate3("widgets.swap-form.swap-button.update-swap-data")}</span>`)}
        ${when2([14 /* waitingApproveTransaction */, 19 /* waitingApproveTransactionForHolder */].includes(this.buttonState), () => html5`<span>${translate3("widgets.swap-form.swap-button.waiting-approve-transaction")}</span>`)}
        ${when2(this.buttonState === 0 /* readyToSwap */, () => html5`<span>${translate3("widgets.swap-form.swap-button.confirm-swap")}</span>`)}
        ${when2(this.buttonState === 1 /* readyToSwapLoading */, () => html5`<span>${translate3("widgets.swap-form.swap-button.confirm-swap")}</span>`)}
        ${when2([9 /* checkAllowance */, 17 /* checkAllowanceForHolder */].includes(this.buttonState), () => html5`<span>${translate3("widgets.swap-form.swap-button.check-allowance")}</span>`)}
        ${when2(this.buttonState === 12 /* wrapNativeToken */, () => html5`<span>${translate3("widgets.swap-form.swap-button.native-token-not-supported")}</span>`)}
        ${when2([10 /* lowAllowanceNeedApprove */, 18 /* lowAllowanceNeedApproveForHolder */].includes(this.buttonState), () => html5`<span>${translate3("widgets.swap-form.swap-button.approve-and-swap")}</span>`)}
        ${when2(this.buttonState === 11 /* lowAllowanceNeedPermit */, () => html5`<span>${translate3("widgets.swap-form.swap-button.permit-and-swap")}</span>`)}
        ${when2(this.buttonState === 3 /* walletNotConnected */, () => html5`<span>${translate3("widgets.swap-form.swap-button.connect-wallet")}</span>`)}
        ${when2(this.buttonState === 4 /* unselectedSourceToken */, () => html5`<span>${translate3("widgets.swap-form.swap-button.select-source-token")}</span>`)}
        ${when2(this.buttonState === 5 /* unselectedDestinationToken */, () => html5`<span>${translate3("widgets.swap-form.swap-button.select-destination-token")}</span>`)}
        ${when2(this.buttonState === 6 /* zeroAmount */, () => html5`<span>${translate3("widgets.swap-form.swap-button.enter-amount-to-swap")}</span>`)}
        ${when2(this.buttonState === 8 /* rateNotExist */, () => html5`<span>${translate3("widgets.swap-form.swap-button.no-liquidity-for-swap")}</span>`)}
        ${when2(this.buttonState === 7 /* exceedingMaximumAmount */, () => html5`
          <span class="off-hover">${translate3("widgets.swap-form.swap-button.insufficient-balance", { symbol: this.srcToken?.symbol })}</span>
          <span class="on-hover">${translate3("widgets.swap-form.swap-button.set-max", { symbol: this.srcToken?.symbol })}</span>
          <br>
        `)}
        ${when2(this.buttonState === 15 /* permitInWallet */, () => html5`
          <span class="off-hover">${translate3("widgets.swap-form.swap-button.wait-wallet-response")}</span>
          <span class="on-hover">${translate3("widgets.swap-form.swap-button.permit-swap-in-wallet")}</span>
          <br>
        `)}
        ${when2([16 /* approveInWallet */, 20 /* approveInWalletForHolder */].includes(this.buttonState), () => html5`
          <span class="off-hover">${translate3("widgets.swap-form.swap-button.wait-wallet-response")}</span>
          <span class="on-hover">${translate3("widgets.swap-form.swap-button.allow-swap-in-wallet")}</span>
          <br>
        `)}
      </inch-button>
    `;
  }
  async onClickSwapButton(event) {
    if (!this.context) {
      throw new Error("Swap context is not initialized");
    }
    const stateState = this.buttonState;
    try {
      if (this.buttonState === 2 /* unsupportedChain */) {
        return dispatchEvent3(this, "changeChain", null);
      }
      if (this.buttonState === 3 /* walletNotConnected */) {
        return dispatchEvent3(this, "connectWallet", null);
      }
      if (this.buttonState === 4 /* unselectedSourceToken */) {
        return dispatchEvent3(this, "openTokenSelector", "source", event);
      }
      if (this.buttonState === 5 /* unselectedDestinationToken */) {
        return dispatchEvent3(this, "openTokenSelector", "destination", event);
      }
      if (this.buttonState === 7 /* exceedingMaximumAmount */) {
        const walletAddress = await firstValueFrom(this.context.connectedWalletAddress$);
        const srcToken = await firstValueFrom(this.sourceToken$);
        if (!walletAddress || !srcToken || !isAddress(walletAddress) || !isAddress(srcToken.address)) {
          dispatchEvent3(this, "connectWallet", null);
          return;
        }
        await this.context.setMaxAmount();
        this.updateView$.next();
        return;
      }
      if (this.buttonState === 18 /* lowAllowanceNeedApproveForHolder */) {
        if (!this.chainId || !isChainId(this.chainId)) throw new Error("Chain ID is null or invalid");
        if (!this.approvalHolder || !isAddress(this.approvalHolder)) throw new Error("Invalid approvalHolder address");
        const holder = this.approvalHolder;
        this.buttonState = 20 /* approveInWalletForHolder */;
        const holderHash = await this.context.getApproveForSpender(holder);
        this.buttonState = 19 /* waitingApproveTransactionForHolder */;
        await waitTransaction(this.chainId, holderHash);
        this.lastHolderCheckToken = this.srcToken;
        const walletAddress = await firstValueFrom(this.connectedWalletAddress$);
        const srcToken = await firstValueFrom(this.sourceToken$);
        const amount = await firstValueFrom(this.sourceTokenAmount$);
        const router = getOneInchRouterV6ContractAddress(this.chainId);
        const allowance = await getAllowance(this.chainId, srcToken.address, walletAddress, router);
        if (amount && allowance < amount) {
          this.buttonState = 16 /* approveInWallet */;
          const routerHash = await this.context.getApproveForSpender(router);
          this.buttonState = 14 /* waitingApproveTransaction */;
          await waitTransaction(this.chainId, routerHash);
          this.lastRouterCheckToken = srcToken;
        }
        this.buttonState = 0 /* readyToSwap */;
        this.updateView$.next();
      }
      if (this.buttonState === 10 /* lowAllowanceNeedApprove */) {
        if (!this.chainId || !isChainId(this.chainId)) throw new Error("Chain ID is null or invalid");
        this.buttonState = 16 /* approveInWallet */;
        const router = getOneInchRouterV6ContractAddress(this.chainId);
        const hash = await this.context.getApproveForSpender(router);
        this.buttonState = 14 /* waitingApproveTransaction */;
        await waitTransaction(this.chainId, hash);
        this.buttonState = 0 /* readyToSwap */;
        this.updateView$.next();
      }
      if (this.buttonState === 11 /* lowAllowanceNeedPermit */) {
        this.buttonState = 15 /* permitInWallet */;
        await this.context.getPermit();
        this.buttonState = 0 /* readyToSwap */;
        this.updateView$.next();
      }
      if (this.buttonState === 12 /* wrapNativeToken */) {
        await this.applicationContext.notificationsController.warning(
          html5`${translate3("widgets.swap-form.swap-button.native-token-not-supported")}`
        );
      }
      if (this.buttonState === 0 /* readyToSwap */) {
        this.buttonState = 1 /* readyToSwapLoading */;
        const snapshot = await this.context.getSnapshot();
        if (snapshot) {
          dispatchEvent3(this, "confirmSwap", snapshot, event);
        }
        this.buttonState = 0 /* readyToSwap */;
        this.updateView$.next();
      }
    } catch (error) {
      this.buttonState = stateState;
      console.error("Swap button error:", error);
    }
  }
  getButtonType() {
    if (this.buttonState === 0 /* readyToSwap */) return "primary";
    if ([10 /* lowAllowanceNeedApprove */, 18 /* lowAllowanceNeedApproveForHolder */].includes(this.buttonState)) return "primary";
    if (this.buttonState === 11 /* lowAllowanceNeedPermit */) return "primary";
    return "secondary";
  }
  getLoaderState() {
    if (showLoader.includes(this.buttonState)) {
      return true;
    }
    return void 0;
  }
  getConnectedWalletAddress() {
    if (!this.context) throw new Error("Context not initialized");
    return this.context.connectedWalletAddress$;
  }
  getChainId() {
    if (!this.context) throw new Error("Context not initialized");
    return this.context.chainId$;
  }
  getSourceToken() {
    if (!this.context) throw new Error("Context not initialized");
    return this.context.getTokenByType("source");
  }
  getDestinationToken() {
    if (!this.context) throw new Error("Context not initialized");
    return this.context.getTokenByType("destination");
  }
  getSourceTokenAmount() {
    if (!this.context) throw new Error("Context not initialized");
    return this.context.getTokenRawAmountByType("source");
  }
  getRate() {
    if (!this.context) throw new Error("Context not initialized");
    return this.context.rate$;
  }
  getLoading() {
    if (!this.context) throw new Error("Context not initialized");
    return this.context.loading$;
  }
  isNeedCheckAllowanceForHolder() {
    if (!this.approvalHolder || !isAddress(this.approvalHolder)) return false;
    if (this.lastHolderCheckToken === null) return true;
    return this.srcToken !== null && !isTokensEqual(this.srcToken, this.lastHolderCheckToken);
  }
  isNeedCheckAllowanceForRouter() {
    if (this.lastRouterCheckToken === null) return true;
    return this.srcToken !== null && !isTokensEqual(this.srcToken, this.lastRouterCheckToken);
  }
};
SwapButtonElement.tagName = "inch-swap-button";
SwapButtonElement.styles = swapButtonStyle;
__decorateClass([
  consume5({ context: SwapContextToken5 })
], SwapButtonElement.prototype, "context", 2);
__decorateClass([
  consume5({ context: ApplicationContextToken3 })
], SwapButtonElement.prototype, "applicationContext", 2);
__decorateClass([
  state2()
], SwapButtonElement.prototype, "isRainbowTheme", 2);
__decorateClass([
  state2()
], SwapButtonElement.prototype, "buttonState", 2);
__decorateClass([
  state2()
], SwapButtonElement.prototype, "chainId", 2);
__decorateClass([
  state2()
], SwapButtonElement.prototype, "srcToken", 2);
__decorateClass([
  CacheActivePromise()
], SwapButtonElement.prototype, "onClickSwapButton", 1);
SwapButtonElement = __decorateClass([
  customElement5(SwapButtonElement.tagName)
], SwapButtonElement);

// libs/widgets/src/lib/swap-form/elements/fusion-swap-info/fusion-swap-info.element.ts
import { html as html9, LitElement as LitElement9 } from "lit";
import { customElement as customElement9 } from "lit/decorators.js";

// libs/widgets/src/lib/swap-form/elements/fusion-swap-info/fusion-swap-info.style.ts
import { css as css7 } from "lit";
var fusionSwapInfoStyle = css7`
  :host {
      display: flex;
      flex-direction: column;
  }
`;

// libs/widgets/src/lib/swap-form/elements/fusion-swap-info/fusion-swap-info.element.ts
import "@one-inch-community/ui-components/icon";
import "@one-inch-community/ui-components/button";

// libs/widgets/src/lib/swap-form/elements/fusion-swap-info-slippage/fusion-swap-info-slippage.element.ts
import { LitElement as LitElement6, html as html6 } from "lit";

// libs/widgets/src/lib/swap-form/elements/fusion-swap-info-slippage/fusion-swap-info-slippage.style.ts
import { mobileMediaCSS as mobileMediaCSS5 } from "@one-inch-community/core/lit";
import { css as css8 } from "lit";
var fusionSwapInfoSlippageStyle = css8`

    .slippage-title {
        display: flex;
        padding: 8px;
        gap: 8px;
        color: var(--color-content-content-primary);
        align-items: center;
        margin-bottom: 8px;
        cursor: pointer;
        font-size: 16px;
    }
    
    .back-icon {
        transform: rotate(90deg);
    }
    
    ${mobileMediaCSS5(css8`
        .slippage-title {
            font-size: 13px;
        }
    `)}

`;

// libs/widgets/src/lib/swap-form/elements/fusion-swap-info-slippage/fusion-swap-info-slippage.element.ts
import { customElement as customElement6, property as property4 } from "lit/decorators.js";
import "@one-inch-community/ui-components/segmented-control";
import "@one-inch-community/ui-components/icon";
import {
  dispatchEvent as dispatchEvent4,
  appendStyle as appendStyle2,
  subscribe as subscribe4,
  getMobileMatchMediaAndSubscribe as getMobileMatchMediaAndSubscribe2,
  translate as translate4
} from "@one-inch-community/core/lit";
import { fromEvent as fromEvent2, tap as tap4 } from "rxjs";
var FusionSwapInfoSlippageElement = class extends LitElement6 {
  constructor() {
    super(...arguments);
    this.mobileMedia = getMobileMatchMediaAndSubscribe2(this);
    this.segmentsCustom = { label: "Custom", value: "custom", template: () => html6`${this.customSlippageInput}` };
    this.segments = [
      { label: "Auto", value: "auto" },
      { label: "0.1%", value: 0.1 },
      { label: "0.5%", value: 0.5 },
      { label: "1%", value: 1 },
      this.segmentsCustom
    ];
    this.postfix = "%";
    this.customSlippageInput = document.createElement("input");
  }
  connectedCallback() {
    super.connectedCallback();
    this.buildMask();
    this.settings?.startChangingValue();
    this.customSlippageInput.placeholder = "Custom %";
    this.customSlippageInput.inputMode = "decimal";
    this.customSlippageInput.autocomplete = "off";
    appendStyle2(this.customSlippageInput, {
      backgroundColor: "transparent",
      border: "none",
      outline: "none",
      padding: "0",
      color: "var(--color-content-content-primary)",
      width: "80px",
      fontSize: "16px",
      textAlign: "center"
    });
    subscribe4(this, [
      fromEvent2(this.customSlippageInput, "input").pipe(
        tap4(() => {
          if (this.customSlippageInput.value.length === 1) {
            this.customSlippageInput.value = "";
          }
          const inputValue = parseFloat(this.customSlippageInput.value.replace(this.postfix, ""));
          this.settings?.setValue([inputValue, "custom"]);
        })
      )
    ], { requestUpdate: false });
  }
  render() {
    appendStyle2(this.customSlippageInput, {
      fontSize: this.mobileMedia.matches ? "13px" : "16px"
    });
    return html6`
      <div @click="${() => this.onBack()}" class="slippage-title">
        <inch-icon class="back-icon" icon="chevronDown16"></inch-icon>
        <span>${translate4("widgets.swap-form.fusion-info.slippage-tolerance")}</span>
      </div>
      <inch-segmented-control
        .items="${this.segments}"
        .select="${this.getStartSection()}"
        @change="${(event) => this.onChange(event)}"
      ></inch-segmented-control>
    `;
  }
  buildMask() {
    return new Maskito(this.customSlippageInput, maskitoNumberOptionsGenerator({
      max: 99,
      min: 1,
      precision: 2,
      postfix: this.postfix
    }));
  }
  onBack() {
    const value = this.settings?.value ?? null;
    if (value && value[1] === "custom" && (value[0] === null || isNaN(value[0]))) {
      this.settings?.resetValue();
    }
    this.settings?.endChangingValue();
    dispatchEvent4(this, "back", null);
  }
  onChange({ detail }) {
    const value = detail.value;
    if (value === "auto") {
      this.settings?.cleanValue();
      return;
    }
    if (value === "custom") {
      const inputValue = parseFloat(this.customSlippageInput.value.replace(this.postfix, ""));
      this.settings?.setValue([inputValue, "custom"]);
      return;
    }
    this.settings?.setValue([detail.value, "preset"]);
  }
  getStartSection() {
    if (!this.settings || this.settings.value === null) return this.segments[0];
    const [value, type] = this.settings.value;
    if (type === "custom") {
      if (isNaN(parseFloat(value))) return this.segments[0];
      this.customSlippageInput.value = `${value}%`;
      return this.segmentsCustom;
    }
    if (type === "preset") {
      const preset = this.segments.find((item) => item.value === value);
      if (!preset) return this.segments[0];
      return preset;
    }
    throw new Error("Invalid slippage type");
  }
};
FusionSwapInfoSlippageElement.tagName = "inch-fusion-swap-info-slippage";
FusionSwapInfoSlippageElement.styles = fusionSwapInfoSlippageStyle;
__decorateClass([
  property4({ type: Object })
], FusionSwapInfoSlippageElement.prototype, "settings", 2);
FusionSwapInfoSlippageElement = __decorateClass([
  customElement6(FusionSwapInfoSlippageElement.tagName)
], FusionSwapInfoSlippageElement);

// libs/widgets/src/lib/swap-form/elements/fusion-swap-info-auction-time/fusion-swap-info-auction-time.element.ts
import { LitElement as LitElement7, html as html7 } from "lit";

// libs/widgets/src/lib/swap-form/elements/fusion-swap-info-auction-time/fusion-swap-info-auction-time.style.ts
import { mobileMediaCSS as mobileMediaCSS6 } from "@one-inch-community/core/lit";
import { css as css9 } from "lit";
var fusionSwapInfoAuctionTimeStyle = css9`

    .slippage-title {
        display: flex;
        padding: 8px;
        gap: 8px;
        color: var(--color-content-content-primary);
        align-items: center;
        margin-bottom: 8px;
        cursor: pointer;
        font-size: 16px;
    }
    
    .back-icon {
        transform: rotate(90deg);
    }
    
    ${mobileMediaCSS6(css9`
        .slippage-title {
            font-size: 13px;
        }
    `)}

`;

// libs/widgets/src/lib/swap-form/elements/fusion-swap-info-auction-time/fusion-swap-info-auction-time.element.ts
import { customElement as customElement7, property as property5 } from "lit/decorators.js";
import "@one-inch-community/ui-components/segmented-control";
import "@one-inch-community/ui-components/icon";
import { dispatchEvent as dispatchEvent5, appendStyle as appendStyle3, subscribe as subscribe5, getMobileMatchMediaAndSubscribe as getMobileMatchMediaAndSubscribe3 } from "@one-inch-community/core/lit";
import { fromEvent as fromEvent3, tap as tap5 } from "rxjs";
import { consume as consume6 } from "@lit/context";
import { ApplicationContextToken as ApplicationContextToken4 } from "@one-inch-community/core/application-context";
var FusionSwapInfoAuctionTimeElement = class extends LitElement7 {
  constructor() {
    super();
    this.mobileMedia = getMobileMatchMediaAndSubscribe3(this);
    this.segmentsCustom = { label: "Custom", value: "custom", template: () => html7`${this.customAuctionTimeInput}` };
    this.postfix = "s";
    this.customAuctionTimeInput = document.createElement("input");
    this.updateSegments();
  }
  connectedCallback() {
    super.connectedCallback();
    this.buildMask();
    this.settings?.startChangingValue();
    this.customAuctionTimeInput.placeholder = "Custom s";
    this.customAuctionTimeInput.inputMode = "decimal";
    this.customAuctionTimeInput.autocomplete = "off";
    appendStyle3(this.customAuctionTimeInput, {
      backgroundColor: "transparent",
      border: "none",
      outline: "none",
      padding: "0",
      color: "var(--color-content-content-primary)",
      width: "80px",
      fontSize: "16px",
      textAlign: "center"
    });
    this.updateSegments();
    subscribe5(this, [
      fromEvent3(this.customAuctionTimeInput, "input").pipe(
        tap5(() => {
          if (this.customAuctionTimeInput.value.length === 1) {
            this.customAuctionTimeInput.value = "";
          }
          const inputValue = this.getValue();
          this.settings?.setValue([inputValue, "custom"]);
        })
      )
    ], { requestUpdate: false });
  }
  render() {
    appendStyle3(this.customAuctionTimeInput, {
      fontSize: this.mobileMedia.matches ? "13px" : "16px"
    });
    return html7`
      <div @click="${() => this.onBack()}" class="slippage-title">
        <inch-icon class="back-icon" icon="chevronDown16"></inch-icon>
        <span>Auction time</span>
      </div>
      <inch-segmented-control
        .items="${this.segments}"
        .select="${this.getStartSection()}"
        @change="${(event) => this.onChange(event)}"
      ></inch-segmented-control>
    `;
  }
  buildMask() {
    return new Maskito(this.customAuctionTimeInput, maskitoNumberOptionsGenerator({
      max: 60 * 60 * 30,
      min: 60 * 3,
      postfix: this.postfix
    }));
  }
  onBack() {
    const value = this.settings?.value ?? null;
    if (value && value[1] === "custom" && (value[0] === null || isNaN(value[0]))) {
      this.settings?.resetValue();
    }
    this.settings?.endChangingValue();
    dispatchEvent5(this, "back", null);
  }
  onChange({ detail }) {
    const value = detail.value;
    if (value === "auto") {
      this.settings?.cleanValue();
      return;
    }
    if (value === "custom") {
      const inputValue = this.getValue();
      this.settings?.setValue([inputValue, "custom"]);
      return;
    }
    this.settings?.setValue([detail.value, "preset"]);
  }
  getStartSection() {
    if (!this.settings || this.settings.value === null) return this.segments[0];
    const [value, type] = this.settings.value;
    if (type === "custom") {
      if (isNaN(parseFloat(value))) return this.segments[0];
      this.customAuctionTimeInput.value = `${value}s`;
      return this.segmentsCustom;
    }
    if (type === "preset") {
      const preset = this.segments.find((item) => item.value === value);
      if (!preset) return this.segments[0];
      return preset;
    }
    throw new Error("Invalid auction time type");
  }
  getValue() {
    const strValue = this.customAuctionTimeInput.value.replaceAll("\xA0", "").replace(this.postfix, "");
    return parseInt(strValue, 10);
  }
  updateSegments() {
    this.segments = [
      { label: "Auto", value: "auto" },
      { label: "3m", value: 60 * 3 },
      { label: "5m", value: 60 * 5 },
      { label: "10m", value: 60 * 10 },
      { label: "30m", value: 60 * 30 },
      this.mobileMedia.matches || this.applicationContext?.isEmbedded ? null : { label: "1H", value: 60 * 60 },
      this.mobileMedia.matches || this.applicationContext?.isEmbedded ? null : { label: "2H", value: 60 * 60 * 2 },
      this.segmentsCustom
    ].filter(Boolean);
  }
};
FusionSwapInfoAuctionTimeElement.tagName = "inch-fusion-swap-info-auction-time";
FusionSwapInfoAuctionTimeElement.styles = fusionSwapInfoAuctionTimeStyle;
__decorateClass([
  property5({ type: Object })
], FusionSwapInfoAuctionTimeElement.prototype, "settings", 2);
__decorateClass([
  consume6({ context: ApplicationContextToken4 })
], FusionSwapInfoAuctionTimeElement.prototype, "applicationContext", 2);
FusionSwapInfoAuctionTimeElement = __decorateClass([
  customElement7(FusionSwapInfoAuctionTimeElement.tagName)
], FusionSwapInfoAuctionTimeElement);

// libs/widgets/src/lib/swap-form/elements/fusion-swap-info-main/fusion-swap-info-main.element.ts
import { html as html8, LitElement as LitElement8 } from "lit";

// libs/widgets/src/lib/swap-form/elements/fusion-swap-info-main/fusion-swap-info-main.style.ts
import { mobileMediaCSS as mobileMediaCSS7 } from "@one-inch-community/core/lit";
import { css as css10 } from "lit";
var fusionSwapInfoMainStyle = css10`
    
    :host {
        --font-size: 16px;
    }
    
    .container {
        height: 56px;
        padding: 16px;
        box-sizing: border-box;
        transition: height .2s, background-color .2s;
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: flex-start;
        justify-content: space-between;
        border-radius: 16px;
        color: var(--color-content-content-primary);
        cursor: pointer;
    }

    .open {
        height: 236px;
        grid-template-rows: min-content 1fr;
        grid-row-gap: 16px;
        cursor: auto;
    }

    .icon {
        transition: transform .2s;
        will-change: transform;
    }

    .open-icon {
        transform: rotate(180deg);
    }

    .fusion-info {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .fusion-icon {
        display: flex;
        align-items: center;
        gap: 4px;
        color: var(--primary);
        text-align: right;
        font-size: var(--font-size);
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        transition: opacity .2s, transform .2s;
        will-change: opacity;
    }

    .fusion-icon-open {
        opacity: 0;
        transform: translate3d(20px, 0, 0);
    }

    .fusion-icon-open:dir(rtl) {
        transform: translate3d(-20px, 0, 0);
    }

    .rate-container {
        width: 100%;
        display: flex;
        align-content: flex-start;
    }

    .rate-view {
        font-size: var(--font-size);
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }

    .rate-view:dir(rtl) {
        direction: ltr;
    }

    .rate-loader {
        background-color: var(--color-background-bg-secondary);
        height: 24px;
        width: 50%;
        border-radius: 8px;
        will-change: filter;
        transition: background-color .2s;
        animation: stub-loader-animation 3s ease-in-out infinite;
    }

    @keyframes stub-loader-animation {
        0%, 100% {
            filter: opacity(1);
        }
        50% {
            filter: opacity(0.5);
        }
    }

    .dst-token-rate-usd-price {
        color: var(--color-content-content-secondary);
        font-size: var(--font-size);
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        margin-left: 4px;
    }
    
    .content-container {
        display: flex;
        grid-row-start: 2;
        grid-row-end: 3;
        height: 100%;
        grid-column-start: 1;
        grid-column-end: 3;
        flex-direction: column;
        visibility: hidden;
        transform: translate3d(0, -15px, 0);
        transition: transform .2s, opacity .2s;
    }
    
    .open .content-container {
        visibility: visible;
        transform: translate3d(0, 0, 0);
    }
    
    .content-row {
        height: 40px;
        padding: 8px 0;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    
    .row-slippage {
        color: var(--primary);
        text-align: right;
        font-size: var(--font-size);
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        cursor: pointer;
    }
    
    .row-title {
        color: var(--color-content-content-secondary);
        font-size: var(--font-size);
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    
    .row-content {
        display: flex;
        align-items: center;
        gap: 4px;
        color: var(--primary);
        text-align: right;
        font-size: var(--font-size);
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        transition: opacity .2s, transform .2s, color .2s;
        will-change: opacity;
    }
    
    .min-receive {
        color: var(--color-content-content-primary);
    }

    @media (hover: hover) {
        .container:not(.open):hover {
            background-color: var(--color-background-bg-secondary);
        }

        .container:not(.open):hover .rate-loader {
            background-color: var(--color-background-bg-positive-hover);
        }
        
        .row-slippage:hover {
            color: var(--primary-hover);
        }
    }
    
    ${mobileMediaCSS7(css10`
        :host {
            --font-size: 13px
        }
        
        .container {
            padding: 16px 8px;
        }
        
        .open {
            grid-row-gap: 0;
            height: 180px;
        }

        .content-row {
            height: 30px;
        }
    `)}
`;

// libs/widgets/src/lib/swap-form/elements/fusion-swap-info-main/fusion-swap-info-main.element.ts
import { customElement as customElement8, property as property6 } from "lit/decorators.js";
import { classMap as classMap2 } from "lit/directives/class-map.js";
import { observe as observe5, dispatchEvent as dispatchEvent6, translate as translate5 } from "@one-inch-community/core/lit";
import { consume as consume7 } from "@lit/context";
import {
  debounceTime as debounceTime2,
  defer as defer6,
  distinctUntilChanged as distinctUntilChanged2,
  map as map6,
  shareReplay as shareReplay3,
  startWith as startWith4,
  switchMap as switchMap6,
  withLatestFrom as withLatestFrom2
} from "rxjs";
import { formatUnits as formatUnits4, parseUnits as parseUnits2 } from "viem";
import "@one-inch-community/ui-components/button";
import "@one-inch-community/ui-components/icon";
import { when as when3 } from "lit/directives/when.js";
import { isRateEqual, isTokensEqual as isTokensEqual2 } from "@one-inch-community/sdk/tokens";
import { formatSeconds, smartFormatAndShorteningNumber, smartFormatNumber as smartFormatNumber2 } from "@one-inch-community/core/formatters";
import { getSymbolFromWrapToken } from "@one-inch-community/sdk/chain";
import { BigMath } from "@one-inch-community/core/math";
import { SwapContextToken as SwapContextToken6 } from "@one-inch-community/sdk/swap";
import { ApplicationContextToken as ApplicationContextToken5 } from "@one-inch-community/core/application-context";
var FusionSwapInfoMainElement = class extends LitElement8 {
  constructor() {
    super(...arguments);
    this.isOpen = false;
    this.rate$ = defer6(() => this.getContext().rate$);
    this.minReceive$ = defer6(() => this.getContext().minReceive$);
    this.chainId$ = defer6(() => this.getContext().chainId$);
    this.destinationToken$ = defer6(() => this.getContext().getTokenByType("destination"));
    this.slippage$ = defer6(() => this.getContext().slippage$).pipe(
      map6((slippage) => {
        return html8`
        ${slippage.value === null ? "" : html8`<span>${slippage.value}% · </span>`}
        <span>
          ${when3(slippage.type === "auto", () => "Auto")}
          ${when3(slippage.type === "custom", () => "Custom")}
          ${when3(slippage.type === "preset", () => "Manual")}
        </span>
      `;
      })
    );
    this.auctionTime$ = defer6(() => this.getContext().auctionTime$).pipe(
      map6((auctionTime) => {
        return html8`
        ${auctionTime.value === null ? "" : html8`<span>${formatSeconds(auctionTime.value)} · </span>`}
        <span>
          ${when3(auctionTime.type === "auto", () => "Auto")}
          ${when3(auctionTime.type === "custom", () => "Custom")}
          ${when3(auctionTime.type === "preset", () => "Manual")}
        </span>
      `;
      })
    );
    this.rateView$ = this.rate$.pipe(
      debounceTime2(0),
      distinctUntilChanged2(rateViewDistinctUntilChangedHandler),
      switchMap6(async (rateData) => {
        if (rateData === null) return this.getLoadRateView();
        const { chainId, rate, revertedRate, sourceToken, destinationToken } = rateData;
        const primaryToken = await this.applicationContext.tokenController.getPriorityToken(chainId, [
          sourceToken.address,
          destinationToken.address
        ]);
        const secondaryToken = isTokensEqual2(primaryToken, sourceToken) ? destinationToken : sourceToken;
        const isRevertedRate = isTokensEqual2(primaryToken, sourceToken);
        const targetRate = isRevertedRate ? revertedRate : rate;
        const rateFormated = smartFormatNumber2(formatUnits4(targetRate, secondaryToken.decimals), 2);
        const tokenPrice = await this.applicationContext.tokenController.getTokenUSDPrice(chainId, secondaryToken.address);
        const rateUsd = parseUnits2(tokenPrice, secondaryToken.decimals);
        const rateUsdFormated = smartFormatNumber2(formatUnits4(rateUsd, secondaryToken.decimals), 2);
        return html8`
        <span class="rate-view">1 ${getSymbolFromWrapToken(secondaryToken)} = ${rateFormated} ${primaryToken.symbol}  <span
          class="dst-token-rate-usd-price">~$${rateUsdFormated}</span></span>
      `;
      }),
      startWith4(this.getLoadRateView()),
      shareReplay3({ bufferSize: 1, refCount: true })
    );
    this.minReceiveView$ = this.minReceive$.pipe(
      withLatestFrom2(this.destinationToken$, this.chainId$),
      switchMap6(async ([minReceive, dstToken, chainId]) => {
        if (!dstToken || !chainId) return html8``;
        const tokenPrice = await this.applicationContext.tokenController.getTokenUSDPrice(chainId, dstToken.address);
        const rateUsd = parseUnits2(tokenPrice, dstToken.decimals);
        const amountUsd = BigMath.mul(
          minReceive,
          rateUsd,
          dstToken.decimals,
          dstToken.decimals
        );
        const amountUsdFormated = smartFormatAndShorteningNumber(formatUnits4(amountUsd, dstToken.decimals), 2);
        return html8`
        <span>~$${amountUsdFormated}</span>
        <span class="min-receive">${smartFormatAndShorteningNumber(formatUnits4(minReceive, dstToken.decimals), 6)} ${dstToken.symbol}</span>
      `;
      })
    );
  }
  connectedCallback() {
    super.connectedCallback();
    dispatchEvent6(this, "changeFusionInfoOpenState", this.isOpen);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    dispatchEvent6(this, "changeFusionInfoOpenState", false);
  }
  render() {
    const classes = {
      container: true,
      open: this.isOpen
    };
    const iconClasses = {
      icon: true,
      "open-icon": this.isOpen
    };
    const fusionIconClass = {
      "fusion-icon": true,
      "fusion-icon-open": this.isOpen
    };
    return html8`
      <div class="${classMap2(classes)}" @click="${() => {
      if (this.isOpen) return;
      this.isOpen = true;
      dispatchEvent6(this, "changeFusionInfoOpenState", this.isOpen);
    }}">
        <div class="rate-container">
          ${observe5(this.rateView$)}
        </div>
        <div class="fusion-info">
          <div class="${classMap2(fusionIconClass)}">
            <inch-icon icon="fusion16"></inch-icon>
            <span>Free</span>
          </div>
          <inch-button @click="${(event) => this.onChangeOpen(event)}" size="l" type="tertiary">
            <inch-icon class="${classMap2(iconClasses)}" icon="chevronDown16"></inch-icon>
          </inch-button>
        </div>
        <div class="content-container">
          <div class="content-row">
            <span class="row-title">${translate5("widgets.swap-form.fusion-info.slippage-tolerance")}</span>
            <div @click="${() => dispatchEvent6(this, "openSlippageSettings", null)}" class="row-content row-slippage">
              ${observe5(this.slippage$)}
            </div>
          </div>
          <div class="content-row">
            <span class="row-title">${translate5("widgets.swap-form.fusion-info.auction-time")}</span>
            <div @click="${() => dispatchEvent6(this, "openAuctionTimeSettings", null)}" class="row-content row-slippage">
              ${observe5(this.auctionTime$)}
            </div>
          </div>
          <div class="content-row">
            <span class="row-title">${translate5("widgets.swap-form.fusion-info.min-receive")}</span>
            <div class="row-content">
              ${observe5(this.minReceiveView$)}
            </div>
          </div>
          <div class="content-row">
            <span class="row-title">${translate5("widgets.swap-form.fusion-info.net-fee")}</span>
            <div class="row-content">
              <inch-icon icon="fusion16"></inch-icon>
              <span>Free</span>
            </div>
          </div>
        </div>
      </div>
    `;
  }
  getLoadRateView() {
    return html8`
      <div class="rate-loader"></div>
    `;
  }
  onChangeOpen(event) {
    event.preventDefault();
    event.stopPropagation();
    this.isOpen = !this.isOpen;
    dispatchEvent6(this, "changeFusionInfoOpenState", this.isOpen);
  }
  getContext() {
    if (!this.context) throw new Error("");
    return this.context;
  }
};
FusionSwapInfoMainElement.tagName = "inch-fusion-swap-info-main";
FusionSwapInfoMainElement.styles = fusionSwapInfoMainStyle;
__decorateClass([
  property6({ type: Boolean })
], FusionSwapInfoMainElement.prototype, "isOpen", 2);
__decorateClass([
  consume7({ context: SwapContextToken6 })
], FusionSwapInfoMainElement.prototype, "context", 2);
__decorateClass([
  consume7({ context: ApplicationContextToken5 })
], FusionSwapInfoMainElement.prototype, "applicationContext", 2);
FusionSwapInfoMainElement = __decorateClass([
  customElement8(FusionSwapInfoMainElement.tagName)
], FusionSwapInfoMainElement);
function rateViewDistinctUntilChangedHandler(rate1, rate2) {
  if (rate1 === null || rate2 === null) {
    return false;
  }
  return isRateEqual(rate1, rate2);
}

// libs/widgets/src/lib/swap-form/elements/fusion-swap-info/fusion-swap-info.element.ts
import { SceneController, shiftAnimation } from "@one-inch-community/ui-components/scene";
import { consume as consume8 } from "@lit/context";
import { SwapContextToken as SwapContextToken7 } from "@one-inch-community/sdk/swap";
var FusionSwapInfoElement = class extends LitElement9 {
  constructor() {
    super(...arguments);
    this.isOpenFusionInfo = false;
    this.scene = new SceneController("main", {
      main: { lazyRender: true, minHeight: 178 },
      slippage: { minHeight: 79.5 },
      auctionTime: { minHeight: 79.5 }
    }, shiftAnimation());
  }
  render() {
    return this.scene.render({
      main: () => html9`
        <inch-fusion-swap-info-main
          .isOpen="${this.isOpenFusionInfo}"
          @openSlippageSettings="${() => this.scene.nextTo("slippage")}"
          @openAuctionTimeSettings="${() => this.scene.nextTo("auctionTime")}"
        ></inch-fusion-swap-info-main>
      `,
      slippage: () => html9`
        <inch-fusion-swap-info-slippage
          .settings="${this.context?.getSettingsController("slippage")}"
          @back="${() => {
        this.isOpenFusionInfo = true;
        this.scene.back();
      }}"
        ></inch-fusion-swap-info-slippage>
      `,
      auctionTime: () => html9`
        <inch-fusion-swap-info-auction-time
          .settings="${this.context?.getSettingsController("auctionTime")}"
          @back="${() => {
        this.isOpenFusionInfo = true;
        this.scene.back();
      }}"
        ></inch-fusion-swap-info-auction-time>
      `
    });
  }
};
FusionSwapInfoElement.tagName = "inch-fusion-swap-info";
FusionSwapInfoElement.styles = [
  fusionSwapInfoStyle,
  SceneController.styles()
];
__decorateClass([
  consume8({ context: SwapContextToken7 })
], FusionSwapInfoElement.prototype, "context", 2);
FusionSwapInfoElement = __decorateClass([
  customElement9(FusionSwapInfoElement.tagName)
], FusionSwapInfoElement);

// libs/widgets/src/lib/swap-form/swap-from.element.ts
var SwapFromElement = class extends LitElement10 {
  constructor() {
    super(...arguments);
    this.fusionView$ = combineLatest6([
      defer7(() => this.getWalletController().data.activeAddress$),
      defer7(() => this.swapContext.getTokenByType("source")),
      defer7(() => this.swapContext.getTokenByType("destination"))
    ]).pipe(
      map7(([address, sourceToken, destinationToken]) => !address || !sourceToken || !destinationToken),
      startWith5(SwapFromElement.lastFusionRenderIsEmptyState),
      distinctUntilChanged3(),
      map7((isEmpty) => {
        SwapFromElement.lastFusionRenderIsEmptyState = isEmpty;
        if (isEmpty) return html10``;
        return html10`<inch-fusion-swap-info></inch-fusion-swap-info>`;
      })
    );
  }
  render() {
    if (!this.swapContext) return;
    return html10`
      <div class="swap-form-container">
        <inch-card-header
          headerText="${translate6("widgets.swap-form.header.swap")}"
          headerTextPosition="left"
        >
          <slot name="header" slot="right-container"></slot>
        </inch-card-header>
        
        <div class="input-container">
          <inch-swap-form-input tokenType="source"></inch-swap-form-input>
          <inch-token-pair-switch></inch-token-pair-switch>
          <inch-swap-form-input disabled tokenType="destination"></inch-swap-form-input>
        </div>
        
        ${observe6(this.fusionView$)}
        
        <inch-swap-button></inch-swap-button>
      </div>
    `;
  }
  getWalletController() {
    if (!this.applicationContext.connectWalletController) throw new Error("");
    return this.applicationContext.connectWalletController;
  }
};
SwapFromElement.tagName = "inch-swap-form";
SwapFromElement.styles = swapFromStyle;
SwapFromElement.lastFusionRenderIsEmptyState = true;
__decorateClass([
  consume9({ context: ApplicationContextToken6 })
], SwapFromElement.prototype, "applicationContext", 2);
__decorateClass([
  consume9({ context: SwapContextToken8, subscribe: true })
], SwapFromElement.prototype, "swapContext", 2);
__decorateClass([
  consume9({ context: EmbeddedConfigToken3 })
], SwapFromElement.prototype, "config", 2);
SwapFromElement = __decorateClass([
  customElement10(SwapFromElement.tagName)
], SwapFromElement);

// libs/widgets/src/lib/swap-form/elements/confirm-swap/confirm-swap.element.ts
import { html as html11, LitElement as LitElement11 } from "lit";
import { customElement as customElement11, property as property7, state as state3 } from "lit/decorators.js";
import { choose as choose2 } from "lit/directives/choose.js";

// libs/widgets/src/lib/swap-form/elements/confirm-swap/confirm-swap.style.ts
import { css as css11 } from "lit";
import { mobileMediaCSS as mobileMediaCSS8 } from "@one-inch-community/core/lit";
var confirmSwapStyle = css11`

    :host {
        --font-size: 16px;
    }
    
    .confirm-swap-view {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .token-view-container {
        background-color: var(--color-background-bg-secondary);
        border-radius: 16px;
        padding: 16px;
    }

    .token-view {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .token-view-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .token-view-top {
        color: var(--color-content-content-secondary);
        font-size: var(--font-size);
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    
    .primary-text {
        color: var(--color-content-content-primary);
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 32px;
    }
    
    .symbol-view {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    
    .separator {
        position: relative;
        color: var(--color-content-content-primary);
    }
    
    .separator-arrow-container {
        border-radius: 50%;
        background-color: var(--color-background-bg-primary);
        width: 32px;
        height: 32px;
        margin-left: auto;
        margin-right: auto;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2;
    }
    
    .separator-arrow-container-loader:before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        border: 1px solid transparent;
        border-radius: 50%;
        border-bottom-color: var(--primary);
        border-top-color: var(--primary);
        animation: spin 2s linear infinite;
    }
    
    .detail-info {
        padding: 8px 0;
    }
    
    .detail-info-row {
        padding: 8px 16px;
        display: flex;
        justify-content: space-between;
    }
    
    .detail-info-row-title {
        color: var(--color-content-content-secondary);
        font-size: var(--font-size);
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    
    .detail-info-raw-value {
        color: var(--color-content-content-primary);
        text-align: right;
        font-size: var(--font-size);
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        transition: color .2s;
        display: flex;
        gap: 8px;
        align-items: center;
    }
    
    .detail-info-raw-settings-value {
        color: var(--primary);
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
    
    .separator-view {
        position: absolute;
        background-color: var(--color-background-bg-primary);
        height: 2px;
        width: 100%;
        border-radius: 2px;
        top: 50%;
        z-index: 1;
    }

    ${mobileMediaCSS8(css11`
        :host {
            --font-size: 13px
        }

        .primary-text {
            font-size: 20px;
        }

        .detail-info-row {
            padding: 4px 8px;
        }

        .token-view {
            gap: 4px;
        }

        .separator-arrow-container {
            width: 28px;
            height: 28px;
        }

        .token-view-container {
            padding: 8px 16px;
        }
    `)}
`;

// libs/widgets/src/lib/swap-form/elements/confirm-swap/confirm-swap.element.ts
import "@one-inch-community/widgets/token-icon";
import "@one-inch-community/widgets/notifications";
import "@one-inch-community/ui-components/card";
import "@one-inch-community/ui-components/button";
import "@one-inch-community/ui-components/icon";
import { formatUnits as formatUnits5, UserRejectedRequestError } from "viem";
import {
  async,
  dispatchEvent as dispatchEvent7,
  getMobileMatchMediaAndSubscribe as getMobileMatchMediaAndSubscribe4,
  observe as observe7,
  translate as translate7
} from "@one-inch-community/core/lit";
import { shareReplay as shareReplay4, switchMap as switchMap7 } from "rxjs";
import { when as when4 } from "lit/directives/when.js";
import { ifDefined as ifDefined3 } from "lit/directives/if-defined.js";
import { isTokensEqual as isTokensEqual3 } from "@one-inch-community/sdk/tokens";
import { formatSeconds as formatSeconds2, smartFormatNumber as smartFormatNumber3 } from "@one-inch-community/core/formatters";
import { getBlockEmitter as getBlockEmitter3, getSymbolFromWrapToken as getSymbolFromWrapToken2, getWrapperNativeToken, isNativeToken as isNativeToken2 } from "@one-inch-community/sdk/chain";
import { consume as consume10 } from "@lit/context";
import { SwapContextToken as SwapContextToken9 } from "@one-inch-community/sdk/swap";
import { ApplicationContextToken as ApplicationContextToken7 } from "@one-inch-community/core/application-context";
var ConfirmSwapElement = class extends LitElement11 {
  constructor() {
    super(...arguments);
    this.state = null;
    this.swapInProgress = false;
    this.fiatAmountMap = /* @__PURE__ */ new Map();
    this.mobileMedia = getMobileMatchMediaAndSubscribe4(this);
  }
  get needWrap() {
    return isNativeToken2(this.swapSnapshot.sourceToken.address);
  }
  render() {
    const size = this.mobileMedia.matches ? "xl" : "xxl";
    return html11`
      <div class="confirm-swap-view">
        <inch-card-header backButton headerTextPosition="center" headerText="Confirm swap" headerTextPosition="left">
        </inch-card-header>
        
        ${this.getTokenViewContainer()}

        ${this.getDetailInfo()}

        <inch-button loader="${ifDefined3(this.swapInProgress ? "" : void 0)}" @click="${() => this.onSwap()}" fullSize size="${size}" type="${this.swapInProgress ? "secondary" : "primary"}">
          ${when4(
      this.swapInProgress,
      () => html11`<span>Confirm swap in wallet</span>`,
      () => html11`<span>Swap</span>`
    )}
        </inch-button>
      </div>
    `;
  }
  async onSwap() {
    if (this.swapInProgress) return;
    try {
      this.swapInProgress = true;
      const hash = await this.swapContext?.swap(this.swapSnapshot);
      dispatchEvent7(this, "backCard", null);
      if (hash) {
        await this.applicationContext.notificationsController.show(
          "Swap status",
          html11`<inch-notification-fusion-swap-view orderHash="${hash}"></inch-notification-fusion-swap-view>`,
          { pinned: true }
        );
      }
    } catch (error) {
      const errorText = parseError(error);
      await this.applicationContext.notificationsController.error(
        html11`${translate7(errorText)}`
      );
      console.error(error);
    }
    this.swapInProgress = false;
  }
  getTokenViewContainer() {
    return html11`
      <div class="token-view-container">
        ${this.getTokenView(this.swapSnapshot.sourceToken, this.swapSnapshot.sourceTokenAmount, "source")}
        ${this.getSeparatorView(this.needWrap ? "wrap" : "swap")}
        ${this.getTokenWrapView()}
        ${this.getTokenView(this.swapSnapshot.destinationToken, this.swapSnapshot.destinationTokenAmount, "destination")}
      </div>
    `;
  }
  getDetailInfo() {
    return html11`
      <div class="detail-info">
        ${this.getDetailInfoRow("Price", html11`${async(this.getRateView())}`)}
        ${this.getDetailInfoRow("Slippage tolerance", this.getSlippageView())}
        ${this.getDetailInfoRow("Auction time", this.getAuctionTimeView())}
        ${this.getDetailInfoRow("Minimum receive", this.getMinReceive())}
        ${this.getDetailInfoRow("Network Fee", html11`
          <div class="detail-info-raw-value detail-info-raw-settings-value">
            <inch-icon icon="fusion16"></inch-icon>
            <span>Free</span>
          </div>
        `)}
      </div>
    `;
  }
  async getRateView() {
    const { chainId, rate, revertedRate, sourceToken, destinationToken } = this.swapSnapshot.rate;
    const primaryToken = await this.applicationContext.tokenController.getPriorityToken(chainId, [
      sourceToken.address,
      destinationToken.address
    ]);
    const secondaryToken = isTokensEqual3(primaryToken, sourceToken) ? destinationToken : sourceToken;
    const isRevertedRate = isTokensEqual3(primaryToken, sourceToken);
    const targetRate = isRevertedRate ? revertedRate : rate;
    const rateFormated = smartFormatNumber3(formatUnits5(targetRate, secondaryToken.decimals), 2);
    return html11`
      <div class="detail-info-raw-value">
        <span class="rate-view">1 ${getSymbolFromWrapToken2(secondaryToken)} = ${rateFormated} ${primaryToken.symbol}</span>
      </div>
    `;
  }
  getSlippageView() {
    const slippage = this.swapSnapshot.slippage;
    return html11`
      <div class="detail-info-raw-value detail-info-raw-settings-value">
        ${slippage.value === null ? "" : html11`<span>${slippage.value}% · </span>`}
        <span>
          ${when4(slippage.type === "auto", () => "Auto")}
          ${when4(slippage.type === "custom", () => "Custom")}
          ${when4(slippage.type === "preset", () => "Manual")}
        </span>
      </div>
      `;
  }
  getAuctionTimeView() {
    const auctionTime = this.swapSnapshot.auctionTime;
    return html11`
      <div class="detail-info-raw-value detail-info-raw-settings-value">
        ${auctionTime.value === null ? "" : html11`<span>${formatSeconds2(auctionTime.value)} · </span>`}
        <span>
          ${when4(auctionTime.type === "auto", () => "Auto")}
          ${when4(auctionTime.type === "custom", () => "Custom")}
          ${when4(auctionTime.type === "preset", () => "Manual")}
      </span>
      </div>
    `;
  }
  getMinReceive() {
    const amountView = formatUnits5(this.swapSnapshot.minReceive, this.swapSnapshot.destinationToken.decimals);
    return html11`
      <div class="detail-info-raw-value">
        ${smartFormatNumber3(amountView, 6)} ${this.swapSnapshot.destinationToken.symbol}
      </div>
    `;
  }
  getDetailInfoRow(title, data) {
    return html11`
      <div class="detail-info-row">
        <span class="detail-info-row-title">${title}</span>
        <span>${data}</span>
      </div>
    `;
  }
  getTokenView(token, amount, type) {
    const amountView = formatUnits5(amount, token.decimals);
    return html11`
      <div class="token-view">
        <div class="token-view-row token-view-top">
          <span>
            ${choose2(type, [
      ["source", () => html11`You pay`],
      ["wrap", () => html11`You wrap`],
      ["destination", () => html11`You receive`]
    ])}
          </span>
          
          <span>${observe7(this.getFiatAmountStream(token, amount))}</span>
        </div>
        <div class="token-view-row">
          <div class="symbol-view">
            <inch-token-icon
              chainId="${this.swapSnapshot.chainId}"
              symbol="${token.symbol}"
              address="${token.address}"
            ></inch-token-icon>
            <span class="primary-text">${token.symbol}</span>
          </div>
          <span class="primary-text">${smartFormatNumber3(amountView, 6)}</span>
        </div>
      </div>
    `;
  }
  getTokenWrapView() {
    if (this.needWrap) {
      return html11`
        ${this.getTokenView(getWrapperNativeToken(this.swapSnapshot.chainId), this.swapSnapshot.sourceTokenAmount, "wrap")}
        ${this.getSeparatorView("swap")}
      `;
    }
    return html11``;
  }
  getSeparatorView(state4) {
    return html11`
      <div class="separator">
        <div class="separator-view"></div>
        <div class="separator-arrow-container ${this.state === state4 && this.needWrap ? "separator-arrow-container-loader" : ""}">
          <inch-icon icon="arrowDown24"></inch-icon>
        </div>
      </div>
    `;
  }
  getFiatAmountStream(token, amount) {
    if (this.fiatAmountMap.has(token.address)) {
      return this.fiatAmountMap.get(token.address);
    }
    const stream = getBlockEmitter3(this.swapSnapshot.chainId).pipe(
      switchMap7(async () => {
        const usdPrice = await this.applicationContext.tokenController.getTokenUSDPrice(this.swapSnapshot.chainId, token.address);
        const balanceFormatted = formatUnits5(amount, token.decimals);
        const balanceUsd = Number(balanceFormatted) * Number(usdPrice);
        return `~$${smartFormatNumber3(balanceUsd.toString(), 2)}`;
      }),
      shareReplay4({ bufferSize: 1, refCount: true })
    );
    this.fiatAmountMap.set(token.address, stream);
    return stream;
  }
};
ConfirmSwapElement.tagName = "inch-confirm-swap";
ConfirmSwapElement.styles = confirmSwapStyle;
__decorateClass([
  property7({ type: Object })
], ConfirmSwapElement.prototype, "swapSnapshot", 2);
__decorateClass([
  consume10({ context: ApplicationContextToken7 })
], ConfirmSwapElement.prototype, "applicationContext", 2);
__decorateClass([
  consume10({ context: SwapContextToken9, subscribe: true }),
  property7({ type: Object, attribute: false })
], ConfirmSwapElement.prototype, "swapContext", 2);
__decorateClass([
  state3()
], ConfirmSwapElement.prototype, "state", 2);
__decorateClass([
  state3()
], ConfirmSwapElement.prototype, "swapInProgress", 2);
ConfirmSwapElement = __decorateClass([
  customElement11(ConfirmSwapElement.tagName)
], ConfirmSwapElement);
function parseError(error) {
  if (error instanceof UserRejectedRequestError) {
    return "widgets.swap-form.swap-button.wallet-rejected";
  }
  return "widgets.swap-form.swap-button.swap-error-message";
}
export {
  ConfirmSwapElement,
  SwapFromElement
};
//# sourceMappingURL=index.esm.js.map
